/* eslint-disable default-case */
import React from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  Row,
  Col,
  Collapse,
  CardBody,
  ButtonGroup,
  Container,
} from "reactstrap";
// import './test.css';
import classnames from "classnames";
import Header from "../HeaderComponent/Header";
import Resize from "./ResizeBenefitTable";
import Recommend from "./ResizeRecommendationTable";
import Health from "./SizingHealthAnalysisTable";
import CostHealthModal from "./CostHealthDetails";
import ColorComponent from "./SvgColorOverview";
import ResingBenefitTextComponent from "./ResingBenefitTextComponent";
import * as message from "../../Constants/MessageConstant";
import * as Constdata from "../../Constants/ApiConstants";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";
import ReactGA from "react-ga4";
import Recommendstatus from "../AnalysisComponent/RecommendetionStatus";
import ValidationTable from "../AnalysisComponent/ValidationTable";
import ValidationDetailsTable from "../AnalysisComponent/ValidationDetailsTable";
import { getStringDate } from "../../Constants/CommonConstant";
import GaiRecommend from "./ResizeGaiRecommendationTable";
import GaiResize from "./ResizeGaiBenefitTable";
import { analysisReport, fetchFont } from "../PdfComponent/PdfFunctions";
import jsPDF from "jspdf";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EntityTypeSummary from "../PdfComponent/reportPdf/EntityTypeSummary";
import ProviderUtils from "../CommonComponent/ProviderUtils";
import { FaSearchPlus } from "react-icons/fa";

let tabType = ["", "Economical", "Balanced", "Enhanced"];
class Overview extends React.Component {
  constructor(props) {
    super(props);
    this.toggleTab = this.toggleTab.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.showCostHealthModal = this.showCostHealthModal.bind(this);
    this.showValidationDetails = this.showValidationDetails.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.closeCostHealthModal = this.closeCostHealthModal.bind(this);
    this.closeValidationDetails = this.closeValidationDetails.bind(this);
    this.getRecommendedData = this.getRecommendedData.bind(this);
    this.handleClientSidePDF = this.handleClientSidePDF.bind(this);
    this.state = {
      providerName:
        this.props.location.state !== undefined
          ? this.props.location.state.providerName
          : "",
      loggedInUser: this.props.location.state.loggedInUser,
      summaryData:
        this.props.location.state !== undefined
          ? this.props.location.state.analysisStatus
          : "",
      viewResultData:
        this.props.location.state !== undefined
          ? this.props.location.state.viewResultData
          : "",
      data:
        this.props.location.state !== undefined
          ? this.props.location.state.data
          : "",
      aggrIcondata:
        this.props.location.state !== undefined
          ? this.props.location.state.aggrIconData
          : [],
      balIcondata:
        this.props.location.state !== undefined
          ? this.props.location.state.balIconData
          : [],
      healthyIcondata:
        this.props.location.state !== undefined
          ? this.props.location.state.healthyIconData
          : [],
      gaiIcondata:
        this.props.location.state !== undefined
          ? this.props.location.state.gaiIconData
          : [],
      modalData: [],
      modal: false,
      isValidationGraphTable: false,
      activeTab:
        this.props.location.state !== undefined
          ? this.props.location.state.actTb
          : "1",
      collapse:
        this.props.location.state !== undefined
          ? [this.props.location.state.actCl, this.props.location.state.atSubCl]
          : [],
      aggBenefitData:
        this.props.location.state !== undefined
          ? this.props.location.state.aggBenefitData
          : [],
      balBenefitData:
        this.props.location.state !== undefined
          ? this.props.location.state.balBenefitData
          : [],
      healthyBenefitData:
        this.props.location.state !== undefined
          ? this.props.location.state.healthyBenefitData
          : [],
      analysisStatus:
        this.props.location.state === undefined
          ? ""
          : this.props.location.state.analysisStatus,
      errorPopup: false,
      errormessage: "",
      isErrorHeader: true,
      modalLoader: false,
      recommendationData:
        this.props.location.state !== undefined
          ? this.props.location.state.data
          : [],
      aggrIcondataStatus:
        this.props.location.state !== undefined
          ? this.props.location.state.aggrIconData
          : [],
      balIcondataStatus:
        this.props.location.state !== undefined
          ? this.props.location.state.balIconData
          : [],
      healthyIcondataStatus:
        this.props.location.state !== undefined
          ? this.props.location.state.healthyIconData
          : [],
      gaiIcondataStatus:
        this.props.location.state !== undefined
          ? this.props.location.state.gaiIconData
          : [],
      isRedirect: true,
      previousView:
        this.props.location.state === undefined
          ? ""
          : this.props.location.state.lastView,
      isAsp:
        this.props.location.state.isAsp !== undefined
          ? this.props.location.state.isAsp
          : false,
      entityType:
        this.props.location.state.entityType !== undefined
          ? this.props.location.state.entityType
          : "vm",
      listTb:
        this.props.location.state.listTb !== undefined
          ? this.props.location.state.listTb
          : "1",
      currentDateTime: this.props.location.state.currentDateTime,
      enhancedCostRatio: this.props.location.state.enhancedCostRatio,
      economicalPerfRatio: this.props.location.state.economicalPerfRatio,
      isClientSidePDF: false,
      activeTabRecommentionsEconomical: 1,
      activeTabRecommentionsBalanced: 1,
      activeTabRecommentionsEnhanced: 1,
      collapseRecommentions: [],
    };
  }

  componentDidMount() {
    // ReactGA.initialize(message.MeasurementId);
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: window.location.pathname,
    //   title: "Analysis Details",
    // });
    this.props.registerListners(true);
    let scrollId = "tab";

    if (this.state.collapse[0] !== undefined) {
      scrollId = scrollId + this.props.location.state.actCl;
    }
    const existsBenefits = this.state.collapse?.some((item) =>
      item?.includes("2-Benefits")
    );
    const existsInsights = this.state.collapse?.some((item) =>
      item?.includes("2-insights")
    );
    if (existsBenefits) {
      scrollId = "tab" + this.props.location.state.atSubCl;
    } else if (existsInsights) {
      scrollId = "tab" + this.props.location.state.atSubCl;
    }
    var ele = document.getElementById(scrollId);
    if (ele !== null) {
      var offset = ele.offsetTop;
      window.scrollTo(0, offset);
    } else {
      window.scrollTo(0, 0);
    }
    let platform =
      this.state.data !== undefined &&
      this.state.data.metricsPlatform === "Host"
        ? " (Only Host Metrics Used)"
        : "";
    var pgAc = document.getElementById("pageRef");
    if (pgAc !== undefined && pgAc !== null) {
      // pgAc.text = (this.state.modal ? "Analysis Details of " : this.state.isValidationGraphTable ? "Simulation Details of " : "Optimization Details of ") + this.state.summaryData.vmname;
      // pgAc.text = (this.state.modal ? "Analysis Details of " + this.state.summaryData.vmname : this.state.isValidationGraphTable ? "Simulation Details of " + this.state.summaryData.vmname : "Rightsizing Analysis of " + this.state.summaryData.vmname +' for '+tabType[this.state.activeTab]+' Goal');
      var header =
        `<div id="dashHeight">
            <div style="display: flex; text-align: center; font-size: 22px; color:#610058;">` +
        (this.state.modal
          ? "Rightsizing Details of " +
            this.state.summaryData.vmname +
            platform +
            " for " +
            tabType[this.state.activeTab] +
            " Goal"
          : this.state.isValidationGraphTable
          ? "Simulation Details of " + this.state.summaryData.vmname + platform
          : "Rightsizing Details of " +
            this.state.summaryData.vmname +
            platform +
            " for " +
            tabType[this.state.activeTab] +
            " Goal") +
        `</div>
            <div style="text-align: center; font-size: 15px; color: #610058;">${getStringDate(
              this.state.currentDateTime
            )} </div>
        </div>`;
      const pageRef = document.getElementById("pageRef");
      pageRef.innerHTML = header;

      pgAc.disabled = true;
      const dashHeight = document.getElementById("dashHeight");
      if (dashHeight) {
        pageRef.style.height = `${dashHeight.offsetHeight}px`;
      }
    }
  }
  getRecommendedData = async (tab) => {
    this.setState({
      modalLoader: true,
      aggrIcondataStatus: [],
      balIcondataStatus: [],
      healthyIcondataStatus: [],
      gaiIcondataStatus: [],
    });
    await fetch(
      `${Constdata.GETRECOMMENDATION_URL}/${tab}/${this.state.data.basicVMID}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    )
      .then((response) => response.json())
      .then(async (responseJson) => {
        if (responseJson.success === true) {
          await this.setState({
            modalLoader: false,
            recommendationData: responseJson.data,
            providerName: responseJson.orgInfo.providerName,
            loggedInUser: responseJson.orgInfo.loggedInUser,
          });
          await this.setState((prevState) => ({
            analysisStatus: {
              ...prevState.analysisStatus,
              status_change_datetime: responseJson.data.status_change_datetime,
            },
          }));
          var aggrIcondata = [];
          var aggrcpu = [];
          var aggrgpu = [];
          var aggrnetwork = [];
          var aggrdisks = [];
          var aggrmemory = [];
          var balIcondata = [];
          var balcpu = [];
          var balnetwork = [];
          var balmemory = [];
          var baldisks = [];
          var healthyIcondata = [];
          var healthycpu = [];
          var healthynetwork = [];
          var healthymemory = [];
          var healthydisks = [];
          var gaiIcondata = [];
          var gaicpu = [];
          var gainetwork = [];
          var gaimemory = [];
          var gaidisks = [];
          responseJson.data.aggressive.vm.map(async (key) => {
            aggrcpu.push({
              costColor: key.current_vcpu_cost,
              healthColor: key.current_vcpu_health,
              icon: "cpu",
              resize: key.vcpuResizeImage,
              status: key.recommendedVMStatus,
            });
            aggrmemory.push({
              costColor: key.current_memory_cost,
              healthColor: key.current_memory_health,
              icon: "memory",
              resize: key.memoryResizeImage,
              status: key.recommendedVMStatus,
            });
            aggrnetwork.push({
              costColor: key.current_network_cost,
              healthColor: key.current_network_health,
              icon: "network",
              resize: key.networkResizeImage,
              status: key.recommendedVMStatus,
            });
          });

          responseJson.data.aggressive.osdisk.slice(0, 1).map(async (key) => {
            aggrdisks.push({
              costColor: key.current_os_disk_cost,
              healthColor: key.current_os_disk_health,
              icon: "osdisk",
              resize: key.osDiskResizeImage,
              status: key.recommendedOSDiskStatus,
            });
          });
          if (this.state.entityType !== "db") {
            Object.keys(responseJson.data.aggressive.dataDisk)
              .sort((a, b) => Number(a) - Number(b))
              .map(async (key) => {
                return responseJson.data.aggressive.dataDisk[key]
                  .slice(0, 1)
                  .map(async (value) => {
                    aggrdisks.push({
                      costColor: value.current_data_disk_cost,
                      healthColor: value.current_data_disk_health,
                      icon: "datadisk",
                      resize: value.diskResizeImage,
                      status: value.recommendedDataDiskStatus,
                    });
                  });
              });
          }

          aggrIcondata.push({
            cpu: aggrcpu,
            memory: aggrmemory,
            network: aggrnetwork,
            disks: aggrdisks,
            gpu: aggrgpu,
          });

          await this.setState(() => ({
            aggrIcondataStatus: aggrIcondata,
          }));

          responseJson.data.balanced.vm.map(async (key) => {
            balcpu.push({
              costColor: key.current_vcpu_cost,
              healthColor: key.current_vcpu_health,
              icon: "cpu",
              resize: key.vcpuResizeImage,
              status: key.recommendedVMStatus,
            });
            balmemory.push({
              costColor: key.current_memory_cost,
              healthColor: key.current_memory_health,
              icon: "memory",
              resize: key.memoryResizeImage,
              status: key.recommendedVMStatus,
            });
            balnetwork.push({
              costColor: key.current_network_cost,
              healthColor: key.current_network_health,
              icon: "network",
              resize: key.networkResizeImage,
              status: key.recommendedVMStatus,
            });
          });

          responseJson.data.balanced.osdisk.slice(0, 1).map(async (key) => {
            baldisks.push({
              costColor: key.current_os_disk_cost,
              healthColor: key.current_os_disk_health,
              icon: "osdisk",
              resize: key.osDiskResizeImage,
              status: key.recommendedOSDiskStatus,
            });
          });
          if (this.state.entityType !== "db") {
            Object.keys(responseJson.data.balanced.dataDisk)
              .sort((a, b) => Number(a) - Number(b))
              .map(async (key) => {
                return responseJson.data.balanced.dataDisk[key]
                  .slice(0, 1)
                  .map(async (value) => {
                    baldisks.push({
                      costColor: value.current_data_disk_cost,
                      healthColor: value.current_data_disk_health,
                      icon: "datadisk",
                      resize: value.diskResizeImage,
                      status: value.recommendedDataDiskStatus,
                    });
                  });
              });
          }
          balIcondata.push({
            cpu: balcpu,
            memory: balmemory,
            network: balnetwork,
            disks: baldisks,
          });

          await this.setState(() => ({
            balIcondataStatus: balIcondata,
          }));
          responseJson.data.conservative.vm.map(async (key) => {
            healthycpu.push({
              costColor: key.current_vcpu_cost,
              healthColor: key.current_vcpu_health,
              icon: "cpu",
              resize: key.vcpuResizeImage,
              status: key.recommendedVMStatus,
            });
            healthymemory.push({
              costColor: key.current_memory_cost,
              healthColor: key.current_memory_health,
              icon: "memory",
              resize: key.memoryResizeImage,
              status: key.recommendedVMStatus,
            });
            healthynetwork.push({
              costColor: key.current_network_cost,
              healthColor: key.current_network_health,
              icon: "network",
              resize: key.networkResizeImage,
              status: key.recommendedVMStatus,
            });
          });

          responseJson.data.conservative.osdisk.slice(0, 1).map(async (key) => {
            healthydisks.push({
              costColor: key.current_os_disk_cost,
              healthColor: key.current_os_disk_health,
              icon: "osdisk",
              resize: key.osDiskResizeImage,
              status: key.recommendedOSDiskStatus,
            });
          });
          if (this.state.entityType !== "db") {
            Object.keys(responseJson.data.conservative.dataDisk)
              .sort((a, b) => Number(a) - Number(b))
              .map(async (key) => {
                return responseJson.data.conservative.dataDisk[key]
                  .slice(0, 1)
                  .map(async (value) => {
                    healthydisks.push({
                      costColor: value.current_data_disk_cost,
                      healthColor: value.current_data_disk_health,
                      icon: "datadisk",
                      resize: value.diskResizeImage,
                      status: value.recommendedDataDiskStatus,
                    });
                  });
              });
          }
          healthyIcondata.push({
            cpu: healthycpu,
            memory: healthymemory,
            network: healthynetwork,
            disks: healthydisks,
          });

          await this.setState(() => ({
            healthyIcondataStatus: healthyIcondata,
          }));

          responseJson.data.gaiValidationData.vm.map(async (key) => {
            gaicpu.push({
              costColor: key.current_vcpu_cost,
              healthColor: key.current_vcpu_health,
              icon: "cpu",
              resize: key.vcpuResizeImage,
              status: key.recommendedVMStatus,
            });
            gaimemory.push({
              costColor: key.current_memory_cost,
              healthColor: key.current_memory_health,
              icon: "memory",
              resize: key.memoryResizeImage,
              status: key.recommendedVMStatus,
            });
            gainetwork.push({
              costColor: key.current_network_cost,
              healthColor: key.current_network_health,
              icon: "network",
              resize: key.networkResizeImage,
              status: key.recommendedVMStatus,
            });
          });

          responseJson.data.gaiValidationData.osdisk
            .slice(0, 1)
            .map(async (key) => {
              gaidisks.push({
                costColor: key.current_os_disk_cost,
                healthColor: key.current_os_disk_health,
                icon: "osdisk",
                resize: key.osDiskResizeImage,
                status: key.recommendedOSDiskStatus,
              });
            });
          if (this.state.entityType !== "db") {
            Object.keys(responseJson.data.gaiValidationData.dataDisk)
              .sort((a, b) => Number(a) - Number(b))
              .map(async (key) => {
                return responseJson.data.gaiValidationData.dataDisk[key]
                  .slice(0, 1)
                  .map(async (value) => {
                    gaidisks.push({
                      costColor: value.current_data_disk_cost,
                      healthColor: value.current_data_disk_health,
                      icon: "datadisk",
                      resize: value.diskResizeImage,
                      status: value.recommendedDataDiskStatus,
                    });
                  });
              });
          }
          gaiIcondata.push({
            cpu: gaicpu,
            memory: gaimemory,
            network: gainetwork,
            disks: gaidisks,
          });

          await this.setState(() => ({
            gaiIcondataStatus: gaiIcondata,
          }));
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
            isRedirect: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
          isRedirect: false,
        });
      });
  };

  handleClose = () => {
    var lastvw =
      this.state.isAsp || this.state.entityType === "db"
        ? "/AspSummary"
        : "/summary";
    this.props.history.push({
      pathname: lastvw,
      state: {
        data: this.state.summaryData,
        oldData: this.state.viewResultData,
        lastView: this.props.location.state.lastView,
        key: this.props.location.state.Listkey,
        isAsp: this.state.isAsp,
        listTb: this.state.listTb,
        entityType: this.state.entityType,
      },
    });
  };
  closeCostHealthModal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      modalLoader: false,
    }));
  };
  closeValidationDetails = () => {
    this.setState((prevState) => ({
      isValidationGraphTable: !prevState.isValidationGraphTable,
      modalLoader: false,
    }));
  };
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  toggleCollapse(tab) {
    if (!this.state.collapse.includes(tab)) {
      this.setState((previousState) => ({
        collapse: [...previousState.collapse, tab],
      }));
    } else {
      var selectedCollapse = this.state.collapse.slice();
      let idx1 = selectedCollapse.indexOf(tab);
      selectedCollapse.splice(idx1, 1);
      this.setState({ collapse: selectedCollapse });
    }
  }
  showCostHealthModal(type) {
    this.setState({ modalLoader: true });
    if (type === "eco") {
      this.setState({
        modalData: this.state.data.aggressive,
        type: "Aggressive",
      });
    } else if (type === "bal") {
      this.setState({
        modalData: this.state.data.balanced,
        type: "Balanced",
      });
    } else if (type === "health") {
      this.setState({
        modalData: this.state.data.conservative,
        type: "Conservative",
      });
    }
    this.setState((prevState) => ({
      modal: !prevState.modal,
      modalLoader: false,
    }));
  }
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.processLogut();
      this.props.history.push("/");
    }
  };
  showValidationDetails() {
    this.setState((prevState) => ({
      isValidationGraphTable: !prevState.isValidationGraphTable,
      modalLoader: false,
    }));
  }

  componentWillUnmount() {
    setTimeout(() => {
      document
        .getElementById("optionDisplay")
        .setAttribute("style", "height: auto;");
      document.getElementsByClassName("container-verf")[0].style.marginTop =
        "50px";
    }, 500);
  }

  handleClientSidePDF = async () => {
    try {
      this.setState({ isClientSidePDF: true, modalLoader: true });

      const doc = new jsPDF();

      const lightFontUrl = require(`../../font/Poppins/Poppins-Light.ttf`);
      const regularFontUrl = require(`../../font/Poppins/Poppins-Regular.ttf`);
      const mediumFontUrl = require(`../../font/Poppins/Poppins-SemiBold.ttf`);
      const boldFontUrl = require(`../../font/Poppins/Poppins-Bold.ttf`);

      const [lightFont, regularFont, mediumFont, boldFont] = await Promise.all([
        fetchFont(lightFontUrl),
        fetchFont(regularFontUrl),
        fetchFont(mediumFontUrl),
        fetchFont(boldFontUrl),
      ]);

      doc.addFileToVFS("Poppins-Light.ttf", lightFont);
      doc.addFileToVFS("Poppins-Regular.ttf", regularFont);
      doc.addFileToVFS("Poppins-Medium.ttf", mediumFont);
      doc.addFileToVFS("Poppins-Bold.ttf", boldFont);

      // Add the fonts to jsdoc
      doc.addFont("Poppins-Light.ttf", "Poppins", "light");
      doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
      doc.addFont("Poppins-Medium.ttf", "Poppins", "medium");
      doc.addFont("Poppins-Bold.ttf", "Poppins", "bold");
      let activeTabGoal = tabType[this.state.activeTab];
      let pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
      let cnt = 1;
      try {
        const lastPage = await analysisReport(
          doc,
          this.state.data,
          this.props,
          this.state,
          pageNumber,
          cnt,
          this.state.economicalPerfRatio,
          this.state.enhancedCostRatio,
          "",
          "",
          "",
          "",
          "",
          activeTabGoal
        );
        pageNumber = lastPage;
      } catch (error) {
        console.error("Error in processing analysis report:", error);
      }
      // Generate PDF

      doc.save(`Console_${this.state.data.name}.pdf`);

      this.setState({ isClientSidePDF: false, modalLoader: false });
    } catch (error) {
      console.error("Error fetching PDF:", error);
      // clearInterval(timer);
      this.setState({
        isClientSidePDF: false,
        modalLoader: false,
        errorPopup: true,
        errormessage: message.CacheErrorTextPdf,
        isErrorHeader: false,
        isRedirect: false,
        isPdfClick: false,
      });
    }
  };

  toggleTabRecommentions(tab, type) {
    if (type === "Balanced") {
      if (this.state.activeTabRecommentionsBalanced !== tab) {
        this.setState({
          activeTabRecommentionsBalanced: tab,
        });
      }
    } else if (type === "Enhanced") {
      if (this.state.activeTabRecommentionsEnhanced !== tab) {
        this.setState({
          activeTabRecommentionsEnhanced: tab,
        });
      }
    } else {
      if (this.state.activeTabRecommentionsEconomical !== tab) {
        this.setState({
          activeTabRecommentionsEconomical: tab,
        });
      }
    }
  }

  openSvgInNewTab = (rf_goal_plot) => {
    const svg = rf_goal_plot;
    if (!svg) return;

    const blob = new Blob([svg], {
      type: "image/svg+xml",
    });

    const url = URL.createObjectURL(blob);

    window.open(url, "_blank", "noopener,noreferrer");
  };

  render() {
    console.log("this.state.collapse", this.state.collapse);
    let hostOnly =
      this.state.data !== undefined &&
      this.state.data.aggressive !== undefined &&
      ProviderUtils.hostOnly(
        this.state.providerName,
        this.state.data.aggressive.metricsPlatform
      );

    const OPEN = (
      <img
        src={require("../../images/OpenArrow_01.png")}
        alt=""
        style={{ maxWidth: "22px", maxHeight: "18px" }}
      />
    );
    const CLOSE = (
      <img
        src={require("../../images/CloseArrow_01.png")}
        alt=""
        style={{ maxWidth: "22px", maxHeight: "18px" }}
      />
    );
    var show = { display: "block", cursor: "pointer" };
    var hide = { display: "none" };
    let forValidation =
      this.state.data.validationData !== null &&
      this.state.data.validationData !== undefined;
    let bvmStatus = this.state.data.bvmState;
    if (
      forValidation === true &&
      (bvmStatus === "VALIDATED" ||
        bvmStatus === "OPTIMALLY SIZED" ||
        bvmStatus === "CUSTOM-SIZED" ||
        bvmStatus === "OPTIMIZING")
    ) {
      bvmStatus = "VALIDATED";
    }

    let platform =
      this.state.data !== undefined &&
      this.state.data.metricsPlatform === "Host"
        ? " (Only Host Metrics Used)"
        : "";
    var pgAc = document.getElementById("pageRef");
    if (pgAc !== undefined && pgAc !== null) {
      var header =
        `<div id="dashHeight">
            <div style="display: flex; text-align: center; font-size: 22px; color:#610058;">` +
        (this.state.modal
          ? "Rightsizing Details of " +
            this.state.summaryData.vmname +
            platform +
            " for " +
            tabType[this.state.activeTab] +
            " Goal"
          : this.state.isValidationGraphTable
          ? "Simulation Details of " + this.state.summaryData.vmname + platform
          : "Rightsizing Details of " +
            this.state.summaryData.vmname +
            platform +
            " for " +
            tabType[this.state.activeTab] +
            " Goal") +
        `</div>
            <div style="text-align: center; font-size: 15px; color: #610058;">${getStringDate(
              this.state.currentDateTime
            )} </div>
        </div>`;
      document.getElementById("pageRef").innerHTML = header;
      pgAc.disabled = true;
    }

    let br = <br />;
    return (
      <div>
        <Header
          processLogout={this.props.processLogut}
          registerListners={this.props.registerListners}
          providerName={this.state.providerName}
          loggedInUser={this.state.loggedInUser}
        />

        <div
          className="container-verf container-verf-padding"
          style={{ marginTop: "50px" }}
          role="main"
        >
          <div className="container1 boxShadow">
            {this.state.data.isResourceChanged !== undefined &&
            this.state.data.isResourceChanged === true ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227", width: "80%" }}>
                    {" "}
                    {bvmStatus === "VALIDATED" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            message.VMResourceChngedFlagInfoTextSummaryValidated +
                            "<br/>" +
                            this.state.data.resourceChangeDetails,
                        }}
                      />
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.isAsp
                            ? message.ASPResourceChngedFlagInfoTextSummaryAnalyzed
                            : this.state.entityType === "db"
                            ? message.DBResourceChngedFlagInfoTextSummaryAnalyzed
                            : message.VMResourceChngedFlagInfoTextSummaryAnalyzed +
                              "<br/>" +
                              this.state.data.resourceChangeDetails,
                        }}
                      />
                    )}
                  </div>
                </div>
              </Row>
            ) : null}

            {this.state.data.isSameMetricPlatform === false &&
            this.state.entityType === "vm" ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227", width: "80%" }}>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.state.data.metricPlatformChangeDetails,
                      }}
                    />
                  </div>
                </div>
              </Row>
            ) : null}

            {this.state.data.priceChangeMsg !== null ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227", width: "80%" }}>
                    <div>{this.state.data.priceChangeMsg}</div>
                  </div>
                </div>
              </Row>
            ) : null}

            {/*<Row>
                                {(this.state.data.metricDataAvalability !== undefined && this.state.data.metricDataAvalability !== null && this.state.data.metricDataAvalability.trim() !== "") ?
                                    <div className="InfoDiv" style={{backgroundColor: "#ffffff", marginBottom: "5px", borderRadius: "7px"}}>
                                        <div style={{color: "#393939", width: "80%"}}><div>Note : {this.state.data.metricDataAvalability}</div></div>
                                    </div> : null }
                            </Row>*/}
            <Row
              className="pageBgHeader"
              style={{
                height: "unset",
                position: "relative",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#E9E9E9",
                borderRadius: "8px 8px 0px 0px",
                flexWrap: "nowrap",
                padding: "2px 0px",
              }}
            >
              <div id="spaceFiller" style={{ width: "8%" }}></div>
              <div
                style={{
                  width: "84%",
                  textAlign: "center",
                  color: "#ffffff",
                  fontSize: "18px",
                  fontWeight: "500",
                }}
              >
                {this.state.data.vminfo}
                <div style={{ fontSize: "18px" }}>
                  {this.state.data && this.state.data.analysisDatetimestamp
                    ? `Analyzed: ${getStringDate(
                        this.state.data.analysisDatetimestamp
                      )}`
                    : null}

                  {this.state.data &&
                  (this.state.data.bvmState === "ANALYZED" ||
                    this.state.data.bvmState === "VERIFIED" ||
                    this.state.data.bvmState === "OPTIMIZED")
                    ? this.state.data.metricDataDurationUsed !== null
                      ? `, ${this.state.data.metricDataDurationUsed}`
                      : null
                    : null}
                </div>
              </div>
              <div
                style={{
                  width: "8%",
                  display: "flex",
                  justifyContent: "flex-end",
                  right: "10px",
                  position: "absolute",
                }}
              >
                <ButtonGroup>
                  <div
                    outline
                    onClick={this.handleClientSidePDF}
                    style={{ marginRight: "5px", cursor: "pointer" }}
                  >
                    <img
                      style={{ margin: "5px" }}
                      src={require("../../images/PDF_Icon1.svg")}
                      title="Save as PDF Report"
                    />
                  </div>
                  {this.state.isValidationGraphTable ? (
                    <div outline onClick={this.closeValidationDetails}>
                      <img
                        src={require("../../images/Close_Icon1.svg")}
                        title="Close"
                      />
                    </div>
                  ) : this.state.modal ? (
                    <div outline onClick={this.closeCostHealthModal}>
                      <img
                        src={require("../../images/Close_Icon1.svg")}
                        title="Close"
                      />
                    </div>
                  ) : (
                    <div
                      outline
                      onClick={this.handleClose}
                      style={this.state.modal ? hide : show}
                    >
                      <img
                        src={require("../../images/Close_Icon1.svg")}
                        title="Close"
                      />
                    </div>
                  )}
                </ButtonGroup>
              </div>
            </Row>
            <div
              className="frm-container pageBgWhite"
              style={{ borderRadius: "0px 0px 10px 10px" }}
            >
              <div>
                {this.state.isValidationGraphTable === true ||
                this.state.modal === true ? null : (
                  <div
                    className="rowContainer"
                    style={{ margin: "0px 0px 0px 0px" }}
                  >
                    <Nav tabs className="navClass">
                      <NavItem style={{ width: "33.33%" }}>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "1",
                          })}
                          onClick={() => {
                            this.toggleTab("1");
                          }}
                        >
                          <b>
                            <h4>
                              Economical
                              <span style={{ fontSize: "22px" }}>
                                (
                                <span style={{ fontStyle: "italic" }}>P90</span>
                                )
                              </span>
                            </h4>
                          </b>
                          <span className="objectiveTagLine">
                            <i>Cost Reducing</i>{" "}
                          </span>
                          <div style={{ fontWeight: "400" }}>
                            {this.state.economicalPerfRatio === 0
                              ? `Lowest Cost regardless of Performance`
                              : `Lower Cost without going below ${this.state.economicalPerfRatio} x Current Performance`}
                          </div>
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ width: "33.33%" }}>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "2",
                          })}
                          onClick={() => {
                            this.toggleTab("2");
                          }}
                        >
                          <b>
                            <h4>
                              Balanced
                              <span style={{ fontSize: "22px" }}>
                                (
                                <span style={{ fontStyle: "italic" }}>P95</span>
                                )
                              </span>
                            </h4>
                          </b>
                          <span className="objectiveTagLine">
                            {" "}
                            <i>Cost Reducing & Performance Improving</i>
                          </span>
                          <div style={{ fontWeight: "400" }}>
                            Lower Cost for Same Performance
                          </div>
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ width: "33.33%" }}>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "3",
                          })}
                          onClick={() => {
                            this.toggleTab("3");
                          }}
                        >
                          <b>
                            {" "}
                            <h4>
                              Enhanced
                              <span style={{ fontSize: "22px" }}>
                                (
                                <span style={{ fontStyle: "italic" }}>
                                  P99.5
                                </span>
                                )
                              </span>
                            </h4>
                          </b>
                          <span className="objectiveTagLine">
                            <i>Performance Improving</i>
                          </span>
                          <div style={{ fontWeight: "400" }}>
                            {this.state.enhancedCostRatio === 999999
                              ? `Highest Performance regardless of Cost`
                              : `Better Performance without exceeding ${this.state.enhancedCostRatio} x Current Cost`}
                          </div>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <Row>
                      <Col id="healthcolor">
                        <lable>
                          <b>Legend</b>
                        </lable>
                        <div className="legendLable">
                          <div className="legendclass Good">Good</div>
                          <div className="legendclass Fair">Fair</div>
                          <div className="legendclass Poor">Poor</div>
                        </div>
                      </Col>
                    </Row>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <div id="tab1">
                          <div
                            color="primary"
                            onClick={() => {
                              this.toggleCollapse("1");
                            }}
                            className="collapsediv"
                          >
                            <div id="collapse_head">
                              <div className="arrow">
                                {!this.state.collapse.includes("1")
                                  ? CLOSE
                                  : OPEN}
                              </div>
                              <div id="overViewCollapseTitle">
                                Rightsizing Analysis
                              </div>
                            </div>
                            {!this.state.collapse.includes("1") ? (
                              <div className="maindiv">
                                {this.state.aggrIcondata[0].gpu &&
                                  this.state.aggrIcondata[0].gpu.length > 0 && (
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].gpu}
                                      isResize={false}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="gpu"
                                    ></ColorComponent>
                                  )}

                                {this.state.aggrIcondata[0].gpumemory &&
                                  this.state.aggrIcondata[0].gpumemory.length >
                                    0 && (
                                    <ColorComponent
                                      data={
                                        this.state.aggrIcondata[0].gpumemory
                                      }
                                      isResize={false}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      // showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="gpumemory"
                                    ></ColorComponent>
                                  )}

                                <ColorComponent
                                  data={this.state.aggrIcondata[0].cpu}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  showCostPerfMarker={
                                    this.state.aggrIcondata[0].gpu &&
                                    this.state.aggrIcondata[0].gpu.length > 0
                                      ? false
                                      : true
                                  }
                                  fromOverview={true}
                                ></ColorComponent>

                                {this.state.entityType === "db" ? (
                                  <ColorComponent
                                    data={this.state.aggrIcondata[0].disks}
                                    isResize={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                  ></ColorComponent>
                                ) : null}
                                <ColorComponent
                                  data={this.state.aggrIcondata[0].memory}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  hostOnly={hostOnly}
                                  fromOverview={true}
                                ></ColorComponent>
                                <ColorComponent
                                  data={this.state.aggrIcondata[0].network}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  fromOverview={true}
                                ></ColorComponent>
                                {this.state.entityType !== "db" ? (
                                  <ColorComponent
                                    data={this.state.aggrIcondata[0].disks}
                                    isResize={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                  ></ColorComponent>
                                ) : null}
                              </div>
                            ) : null}{" "}
                          </div>
                          <Collapse
                            isOpen={this.state.collapse.includes("1")}
                            className="collapseTransition"
                          >
                            <Card style={{ border: "none" }}>
                              <CardBody style={{ border: "none" }}>
                                <Row>
                                  <Col sm="9">
                                    <Health
                                      data={this.state.data.aggressive}
                                      iconData={this.state.aggrIcondata}
                                      isResize={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      providerName={this.state.providerName}
                                    ></Health>
                                  </Col>
                                  <Col
                                    sm="3"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      marginTop: "220px",
                                      marginBottom: "auto",
                                    }}
                                  >
                                    <Button
                                      className="btn-common"
                                      onClick={() => {
                                        this.showCostHealthModal("eco");
                                      }}
                                    >
                                      Show Analysis Details
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Collapse>
                        </div>
                        <div id="tab2">
                          <div
                            onClick={() => {
                              this.toggleCollapse("2");
                              this.setState({
                                activeTabRecommentionsEconomical: 1,
                              });
                            }}
                            className="collapsediv"
                          >
                            <div id="collapse_head">
                              <div className="arrow">
                                {!this.state.collapse.includes("2")
                                  ? CLOSE
                                  : OPEN}
                              </div>
                              <div id="overViewCollapseTitle">
                                Rightsizing Recommendation(s)
                              </div>
                            </div>
                            {!this.state.collapse.includes("2") ? (
                              <div className="maindiv">
                                {this.state.aggrIcondata[0].gpu &&
                                  this.state.aggrIcondata[0].gpu.length > 0 && (
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].gpu}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  )}
                                {this.state.aggrIcondata[0].gpumemory &&
                                  this.state.aggrIcondata[0].gpumemory.length >
                                    0 && (
                                    <ColorComponent
                                      data={
                                        this.state.aggrIcondata[0].gpumemory
                                      }
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      // showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  )}

                                <ColorComponent
                                  data={this.state.aggrIcondata[0].cpu}
                                  isResize={true}
                                  isLine={true}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  showCostPerfMarker={
                                    this.state.aggrIcondata[0].gpu &&
                                    this.state.aggrIcondata[0].gpu.length > 0
                                      ? false
                                      : true
                                  }
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                {this.state.entityType === "db" ? (
                                  <ColorComponent
                                    data={this.state.aggrIcondata[0].disks}
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                ) : null}
                                <ColorComponent
                                  data={this.state.aggrIcondata[0].memory}
                                  isResize={true}
                                  isLine={true}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  hostOnly={hostOnly}
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                <ColorComponent
                                  data={this.state.aggrIcondata[0].network}
                                  isResize={true}
                                  isLine={
                                    this.state.entityType === "db"
                                      ? false
                                      : true
                                  }
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                {this.state.entityType !== "db" ? (
                                  <ColorComponent
                                    data={this.state.aggrIcondata[0].disks}
                                    isResize={true}
                                    isLine={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                ) : null}
                              </div>
                            ) : (
                              <>
                                <Container
                                  fluid
                                  style={{
                                    position: "relative",
                                    bottom: "-22px",
                                  }}
                                >
                                  <Row className="justify-content-flex-start d-flex align-items-stretch">
                                    {this.state.data.aggressive.vm.map(
                                      (item, index) => {
                                        const foundDisk =
                                          this.state.data.aggressive?.osdisk &&
                                          Array.isArray(
                                            this.state.data.aggressive.osdisk
                                          )
                                            ? this.state.data.aggressive.osdisk.find(
                                                (disk) =>
                                                  disk.recommendationChoiceNum ===
                                                  item?.recommendationChoiceNum
                                              )
                                            : null;

                                        var current_os_disk_name =
                                          foundDisk?.recommended_os_disk_name +
                                          "-" +
                                          foundDisk?.recommended_os_disk_memory;

                                        const dataDisk =
                                          Object.values(
                                            this.state.data.aggressive
                                              ?.dataDisk || {}
                                          )
                                            .flat()
                                            .filter(
                                              (disk) =>
                                                disk.recommendationChoiceNum ===
                                                item?.recommendationChoiceNum
                                            )
                                            .map(
                                              (disk) =>
                                                `${disk.recommended_data_disk_name}-${disk.recommended_data_disk_memory}`
                                            )
                                            .join(", ") || "";

                                        return (
                                          <Col
                                            key={index}
                                            md="3"
                                            className={`text-center d-flex align-items-center justify-content-center recommendation-card-box ${
                                              this.state
                                                .activeTabRecommentionsEconomical ===
                                              item?.recommendationChoiceNum + 1
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (
                                                !this.state.collapse.includes(
                                                  "2"
                                                )
                                              ) {
                                                this.toggleCollapse("2");
                                              }
                                              this.toggleTabRecommentions(
                                                item?.recommendationChoiceNum +
                                                  1,
                                                "Economical"
                                              );
                                            }}
                                          >
                                            <div style={{ padding: "7px 0px" }}>
                                              <h6 className="fw-bold">
                                                {item?.recommendationChoiceNum ===
                                                0
                                                  ? "Default Recommendation"
                                                  : "Alternate " +
                                                    item?.recommendationChoiceNum +
                                                    " Recommendation"}
                                              </h6>
                                              <div className="fw-bold">
                                                {`(${
                                                  item.recommended_vmsize_name
                                                }, (${current_os_disk_name}${
                                                  dataDisk
                                                    ? `, ${dataDisk})`
                                                    : ")"
                                                })`}
                                              </div>
                                            </div>
                                          </Col>
                                        );
                                      }
                                    )}
                                  </Row>
                                </Container>
                              </>
                            )}
                          </div>
                          <Collapse
                            isOpen={this.state.collapse.includes("2")}
                            className="collapseTransition"
                          >
                            <TabContent
                              activeTab={
                                this.state.activeTabRecommentionsEconomical
                              }
                            >
                              {this.state.data.aggressive.vm.map(
                                (item, index) => (
                                  <>
                                    <TabPane
                                      key={index + 1}
                                      tabId={
                                        (item?.recommendationChoiceNum || 0) + 1
                                      }
                                    >
                                      <Card style={{ border: "none" }}>
                                        <CardBody style={{ border: "none" }}>
                                          <Recommend
                                            data={this.state.data.aggressive}
                                            iconData={this.state.aggrIcondata}
                                            isResize={true}
                                            isLine={true}
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                            userCurrency={
                                              this.state.data?.userCurrency
                                            }
                                            providerName={
                                              this.state.providerName
                                            }
                                            type="recommendation"
                                            tabID={
                                              item?.recommendationChoiceNum || 0
                                            }
                                          ></Recommend>
                                        </CardBody>
                                      </Card>

                                      <div
                                        id="tab1-2-Benefits"
                                        color="primary"
                                        onClick={() => {
                                          this.toggleCollapse("1-2-Benefits");
                                        }}
                                        className="collapsediv"
                                      >
                                        <div id="collapse_head">
                                          <div className="arrow">
                                            {!this.state.collapse.includes(
                                              "1-2-Benefits"
                                            )
                                              ? CLOSE
                                              : OPEN}
                                          </div>
                                          <div id="overViewCollapseTitle">
                                            Benefits and Drawbacks
                                            {item?.recommendationChoiceNum === 0
                                              ? ""
                                              : " (Alternate " +
                                                item?.recommendationChoiceNum +
                                                " Recommendation)"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Inner Collapse */}
                                      <Collapse
                                        isOpen={this.state.collapse.includes(
                                          "1-2-Benefits"
                                        )}
                                        className="collapseTransition"
                                      >
                                        <div
                                          className="overviewTextCompParent"
                                          style={{ paddingLeft: "20px" }}
                                        >
                                          {this.state.data.aggressive
                                            ?.summaryList &&
                                            this.state.data.aggressive.summaryList
                                              .filter(
                                                (itemCost) =>
                                                  itemCost.recommendationChoiceNum ===
                                                  item.recommendationChoiceNum
                                              )
                                              .map(
                                                (filteredItem, index) =>
                                                  filteredItem.costSummaryText !==
                                                    undefined &&
                                                  filteredItem.costSummaryText !==
                                                    null && (
                                                    <div
                                                      key={index}
                                                      className="maindiv-text-overview maindiv-text-overview-grad"
                                                    >
                                                      <div className="expected-cost-title">
                                                        Expected Cost Effect
                                                      </div>
                                                      <ResingBenefitTextComponent
                                                        title={
                                                          filteredItem.costSummaryText
                                                        }
                                                        data={
                                                          filteredItem.costSummaryDescription
                                                        }
                                                        isAsp={this.state.isAsp}
                                                        entityType={
                                                          this.state.entityType
                                                        }
                                                      />
                                                    </div>
                                                  )
                                              )}

                                          {this.state.data.aggressive
                                            ?.summaryList &&
                                            this.state.data.aggressive.summaryList
                                              .filter(
                                                (itemPerformance) =>
                                                  item.recommendationChoiceNum ===
                                                  itemPerformance.recommendationChoiceNum
                                              )
                                              .map(
                                                (filteredItem, index) =>
                                                  filteredItem.perfSummaryText !==
                                                    undefined &&
                                                  filteredItem.perfSummaryText !==
                                                    null && (
                                                    <div
                                                      key={index}
                                                      className="maindiv-text-overview maindiv-text-overview-grad"
                                                    >
                                                      <div className="expected-cost-title">
                                                        Expected Performance
                                                        Effect
                                                      </div>
                                                      <ResingBenefitTextComponent
                                                        title={
                                                          filteredItem.perfSummaryText
                                                        }
                                                        data={
                                                          filteredItem.perfSummaryDescription
                                                        }
                                                        isAsp={this.state.isAsp}
                                                        entityType={
                                                          this.state.entityType
                                                        }
                                                      />
                                                    </div>
                                                  )
                                              )}
                                        </div>
                                      </Collapse>

                                      <div
                                        id="tab1-2-insights"
                                        color="primary"
                                        onClick={() => {
                                          this.toggleCollapse("1-2-insights");
                                        }}
                                        className="collapsediv"
                                      >
                                        <div id="collapse_head">
                                          <div className="arrow">
                                            {!this.state.collapse.includes(
                                              "1-2-insights"
                                            )
                                              ? CLOSE
                                              : OPEN}
                                          </div>
                                          <div id="overViewCollapseTitle">
                                            Insights and Actions{" "}
                                            {item?.recommendationChoiceNum === 0
                                              ? ""
                                              : " (Alternate " +
                                                item?.recommendationChoiceNum +
                                                " Recommendation)"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Inner Collapse */}
                                      <Collapse
                                        isOpen={this.state.collapse.includes(
                                          "1-2-insights"
                                        )}
                                        className="collapseTransition"
                                      >
                                        <div
                                          className="overviewTextCompParent"
                                          style={{ paddingLeft: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              flexDirection: item?.rf_goal_plot
                                                ? "column"
                                                : "row",
                                            }}
                                            className="maindiv-text-overview"
                                          >
                                            {item.gaiInsightSummary !==
                                              undefined &&
                                              item.gaiInsightSummary !==
                                                null && (
                                                <div
                                                  className="maindiv-text-summary-grad mb-5 pr-2"
                                                  key={index}
                                                  style={{
                                                    width: item?.rf_goal_plot
                                                      ? "unset"
                                                      : "50%",
                                                  }}
                                                >
                                                  <div className="expected-cost-title">
                                                    AI Insights
                                                  </div>
                                                  <ResingBenefitTextComponent
                                                    title={
                                                      item.gaiInsightSummary
                                                    }
                                                    data={[
                                                      item.gaiInsightDescription,
                                                    ]}
                                                    isAsp={this.state.isAsp}
                                                    entityType={
                                                      this.state.entityType
                                                    }
                                                  />
                                                </div>
                                              )}

                                            <div
                                              className="maindiv-text-summary-grad"
                                              style={{
                                                width: item?.rf_goal_plot
                                                  ? "unset"
                                                  : "50%",
                                              }}
                                            >
                                              <div className="expected-cost-title mb-2">
                                                Actions
                                              </div>
                                              <ul
                                                style={{
                                                  textAlign: "left",
                                                  paddingRight: "5px",
                                                }}
                                              >
                                                {item?.recommendationActions?.map(
                                                  (action, index) => (
                                                    <React.Fragment key={index}>
                                                      <li key={index}>
                                                        {action}
                                                      </li>
                                                    </React.Fragment>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>

                                          {item.rf_goal_plot !== undefined &&
                                          item.rf_goal_plot !== null ? (
                                            <React.Fragment key={index}>
                                              <div>
                                                <div className="expected-cost-title mb-2">
                                                  Visual Insight
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                  }}
                                                >
                                                  <div
                                                    className="svg-container"
                                                    style={{ width: "unset" }}
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        item?.rf_goal_plot,
                                                    }}
                                                  />
                                                  <div
                                                    className="svg-view-icon"
                                                    style={{
                                                      position: "relative",
                                                      right: 40,
                                                      top: 5,
                                                    }}
                                                    title="Open image in new tab"
                                                    onClick={() =>
                                                      this.openSvgInNewTab(
                                                        item?.rf_goal_plot
                                                      )
                                                    }
                                                  >
                                                    <FaSearchPlus size={24} />
                                                  </div>
                                                </div>
                                              </div>
                                            </React.Fragment>
                                          ) : null}
                                        </div>
                                      </Collapse>
                                    </TabPane>
                                  </>
                                )
                              )}
                            </TabContent>

                            {/* <div
                              className="overviewTextCompParent"
                              style={{ paddingLeft: "20px" }}
                            >
                              {this.state.data.aggressive?.summaryList &&
                                this.state.data.aggressive.summaryList
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEconomical - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.costSummaryText !==
                                        undefined &&
                                      filteredItem.costSummaryText !== null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            Expected Cost Effect
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={filteredItem.costSummaryText}
                                            data={
                                              filteredItem.costSummaryDescription
                                            }
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}

                              {this.state.data.aggressive?.summaryList &&
                                this.state.data.aggressive.summaryList
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEconomical - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.perfSummaryText !==
                                        undefined &&
                                      filteredItem.perfSummaryText !== null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            Expected Performance Effect
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={filteredItem.perfSummaryText}
                                            data={
                                              filteredItem.perfSummaryDescription
                                            }
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}

                              {this.state.data.aggressive?.vm &&
                                this.state.data.aggressive.vm
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEconomical - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.gaiInsightSummary !==
                                        undefined &&
                                      filteredItem.gaiInsightSummary !==
                                        null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            AI Insights
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={
                                              filteredItem.gaiInsightSummary
                                            }
                                            data={[
                                              filteredItem.gaiInsightDescription,
                                            ]}
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}
                            </div> */}

                            {/* {this.state.data.aggressive?.vm &&
                              this.state.data.aggressive.vm
                                .filter(
                                  (item) =>
                                    item.rf_goal_plot !== undefined &&
                                    item.rf_goal_plot !== null &&
                                    item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEconomical - 1
                                      )
                                )
                                .map((filteredItem, index) => (
                                  <React.Fragment key={index}>
                                    <hr
                                      style={{
                                        width: "98%",
                                        height: "10px",
                                      }}
                                    />
                                    <h6>
                                      {filteredItem?.recommendationChoiceNum ===
                                      0
                                        ? "Resource Fit Graph"
                                        : "Alternate " +
                                          filteredItem?.recommendationChoiceNum +
                                          " Recommendation Resource Fit Graph"}
                                    </h6>

                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        className="svg-container"
                                        style={{ width: "unset" }}
                                        dangerouslySetInnerHTML={{
                                          __html: filteredItem?.rf_goal_plot,
                                        }}
                                      />
                                      <div
                                        className="svg-view-icon"
                                        style={{
                                          position: "relative",
                                          right: 40,
                                          top: 5,
                                        }}
                                        title="Open image in new tab"
                                        onClick={() =>
                                          this.openSvgInNewTab(
                                            filteredItem?.rf_goal_plot
                                          )
                                        }
                                      >
                                        <FaSearchPlus />
                                      </div>
                                    </div>
                                  </React.Fragment>
                                ))} */}
                          </Collapse>
                        </div>

                        {/* GAI Recommendation */}
                        {this.state.data &&
                        this.state.data.gaiValidationData &&
                        this.state.data.gaiValidationData.validationPerfType ===
                          "Aggressive" ? (
                          <>
                            <div id="tab19">
                              <div
                                onClick={() => {
                                  this.toggleCollapse("19");
                                }}
                                className="collapsediv"
                              >
                                <div id="collapse_head">
                                  <div className="arrow">
                                    {!this.state.collapse.includes("19")
                                      ? CLOSE
                                      : OPEN}
                                  </div>
                                  <div id="overViewCollapseTitle">
                                    GAI Recommendation
                                  </div>
                                </div>
                                {!this.state.collapse.includes("19") ? (
                                  <div className="maindiv">
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].cpu}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType === "db" ? (
                                      <ColorComponent
                                        data={this.state.aggrIcondata[0].disks}
                                        isResize={true}
                                        isLine={true}
                                        showInfo={false}
                                        isAsp={this.state.isAsp}
                                        entityType={this.state.entityType}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].memory}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      hostOnly={hostOnly}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].network}
                                      isResize={true}
                                      isLine={
                                        this.state.entityType === "db"
                                          ? false
                                          : true
                                      }
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType !== "db" ? (
                                      <ColorComponent
                                        data={this.state.aggrIcondata[0].disks}
                                        isResize={true}
                                        isLine={false}
                                        showInfo={false}
                                        isAsp={this.state.isAsp}
                                        entityType={this.state.entityType}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                  </div>
                                ) : null}
                              </div>
                              <Collapse
                                isOpen={this.state.collapse.includes("19")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <GaiRecommend
                                      data={this.state.data.gaiValidationData}
                                      iconData={this.state.aggrIcondata}
                                      isResize={true}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      userCurrency={
                                        this.state.data?.userCurrency
                                      }
                                      providerName={this.state.providerName}
                                    ></GaiRecommend>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </div>

                            {/* Expected Benefits & Drawbacks of GAI Recommendation               */}
                            <div id="tab20">
                              <div
                                color="primary"
                                onClick={() => {
                                  this.toggleCollapse("20");
                                }}
                                className="collapsediv resize-collapsediv"
                              >
                                <div
                                  id="collapse_head"
                                  style={{
                                    minHeight: "102px",
                                    maxWidth: "28%",
                                  }}
                                >
                                  <div className="arrow">
                                    {!this.state.collapse.includes("20")
                                      ? CLOSE
                                      : OPEN}
                                  </div>
                                  <div id="overViewCollapseTitle">
                                    Expected Benefits & Drawbacks of GAI
                                    Recommendation
                                  </div>{" "}
                                </div>{" "}
                                {!this.state.collapse.includes("20") ? (
                                  <div className="overviewTextCompParent">
                                    {this.state.data.gaiValidationData !==
                                      undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .costSummaryText !== undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .costSummaryText !== null ? (
                                      <div className="maindiv-text-overview maindiv-text-overview-grad">
                                        <ResingBenefitTextComponent
                                          title={
                                            this.state.data.gaiValidationData
                                              .summary.costSummaryText
                                          }
                                          data={
                                            this.state.data.gaiValidationData
                                              .summary.costSummaryDescription
                                          }
                                          isAsp={this.state.isAsp}
                                          entityType={this.state.entityType}
                                        />
                                      </div>
                                    ) : null}
                                    {this.state.data.gaiValidationData !==
                                      undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .perfSummaryText !== undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .perfSummaryText !== null ? (
                                      <div className="maindiv-text-overview maindiv-text-overview-grad">
                                        <ResingBenefitTextComponent
                                          data={
                                            this.state.data.gaiValidationData
                                              .summary.perfSummaryDescription
                                          }
                                          title={
                                            this.state.data.gaiValidationData
                                              .summary.perfSummaryText
                                          }
                                          isAsp={this.state.isAsp}
                                          entityType={this.state.entityType}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                ) : null}
                              </div>
                              <Collapse
                                isOpen={this.state.collapse.includes("20")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <GaiResize
                                      data={this.state.data.gaiValidationData}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      userCurrency={
                                        this.state.data?.userCurrency
                                      }
                                      providerName={this.state.providerName}
                                    ></GaiResize>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </div>
                          </>
                        ) : null}

                        {/* Validation : */}
                        {this.state.isValidationGraphTable === false &&
                        this.state.data.validationData !== null &&
                        this.state.data.validationData !== undefined &&
                        this.state.data.validationData.perfType ===
                          "Aggressive" ? (
                          <div id="tab4">
                            <div
                              onClick={() => {
                                this.toggleCollapse("4");
                              }}
                              className="collapsediv"
                            >
                              <div id="collapse_head">
                                <div className="arrow">
                                  {!this.state.collapse.includes("4")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div>
                                  <div id="overViewCollapseTitle">
                                    Validation :
                                  </div>
                                  <div>
                                    <b>Economical</b>
                                  </div>
                                  <div>{bvmStatus}</div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("4") ? (
                                this.state.aggrIcondata.length > 0 ? (
                                  <div className="maindiv">
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].cpu}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Economical"
                                      valData={this.state.data.validationData}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType === "db" ? (
                                      <ColorComponent
                                        data={this.state.aggrIcondata[0].disks}
                                        isResize={true}
                                        isLine={true}
                                        showInfo={false}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        forValidation={true}
                                        valObjective="Economical"
                                        valData={this.state.data.validationData}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].memory}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Economical"
                                      valData={this.state.data.validationData}
                                      hostOnly={hostOnly}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    <ColorComponent
                                      data={this.state.aggrIcondata[0].network}
                                      isResize={true}
                                      isLine={
                                        this.state.entityType === "db"
                                          ? false
                                          : true
                                      }
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Economical"
                                      valData={this.state.data.validationData}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType !== "db" ? (
                                      <ColorComponent
                                        data={this.state.aggrIcondata[0].disks}
                                        isResize={true}
                                        isLine={false}
                                        showInfo={false}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        forValidation={true}
                                        valObjective="Economical"
                                        valData={this.state.data.validationData}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                  </div>
                                ) : null
                              ) : null}
                            </div>
                            <Collapse
                              isOpen={this.state.collapse.includes("4")}
                              className="collapseTransition"
                            >
                              <Card style={{ border: "none" }}>
                                <CardBody style={{ border: "none" }}>
                                  <div>
                                    <ValidationTable
                                      data={
                                        this.state.recommendationData.aggressive
                                      }
                                      valTableData={
                                        this.state.data.validationData
                                      }
                                      iconData={this.state.aggrIcondata}
                                      isResize={true}
                                      isLine={true}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      valObjective="Economical"
                                      showValidationDetails={
                                        this.showValidationDetails
                                      }
                                    ></ValidationTable>
                                  </div>
                                </CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        ) : null}

                        {/* Validated Benefits & Drawbacks of Recommendation */}
                        {this.state.isValidationGraphTable === false &&
                        this.state.data.validationData !== null &&
                        this.state.data.validationData !== undefined &&
                        this.state.data.validationData.perfType ===
                          "Aggressive" &&
                        bvmStatus === "VALIDATED" ? (
                          <div id="5">
                            <div
                              onClick={() => {
                                this.toggleCollapse("5");
                              }}
                              className="collapsediv resize-collapsediv"
                            >
                              <div
                                id="collapse_head"
                                style={{ maxWidth: "29%" }}
                              >
                                <div className="arrow">
                                  {!this.state.collapse.includes("5")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div>
                                  <div
                                    id="overViewCollapseTitle"
                                    style={{ fontSize: "20px" }}
                                  >
                                    Validated Benefits & Drawbacks of
                                    Recommendation :{" "}
                                  </div>
                                  <div>
                                    <b>Economical</b>
                                  </div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("5") ? (
                                <div className="overviewTextCompParent">
                                  {this.state.data.aggressive !== undefined &&
                                  this.state.data.aggressive.validation_summary
                                    .costSummaryText !== undefined &&
                                  this.state.data.aggressive.validation_summary
                                    .costSummaryText !== null ? (
                                    <div className="maindiv-text-overview maindiv-text-overview-grad">
                                      <ResingBenefitTextComponent
                                        title={
                                          this.state.data.aggressive
                                            .validation_summary.costSummaryText
                                        }
                                        data={
                                          this.state.data.aggressive
                                            .validation_summary
                                            .costSummaryDescription
                                        }
                                        affectString={
                                          this.state.data.aggressive
                                            .validation_summary.perfAffected
                                        }
                                        valResult={
                                          this.state.data.aggressive
                                            .validation_summary
                                            .validation_cost_result
                                        }
                                        renderIcon={
                                          this.state.data.validationPerfType !==
                                            null &&
                                          this.state.data.validationPerfType ===
                                            "Aggressive" &&
                                          this.state.data.bvmState !==
                                            "VALIDATING"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                  {this.state.data.aggressive !== undefined &&
                                  this.state.data.aggressive.validation_summary
                                    .perfSummaryText !== undefined &&
                                  this.state.data.aggressive.validation_summary
                                    .perfSummaryText !== null ? (
                                    <div className="maindiv-text-overview maindiv-text-overview-grad">
                                      <ResingBenefitTextComponent
                                        data={
                                          this.state.data.aggressive
                                            .validation_summary
                                            .perfSummaryDescription
                                        }
                                        title={
                                          this.state.data.aggressive
                                            .validation_summary.perfSummaryText
                                        }
                                        affectString={
                                          this.state.data.aggressive.summary
                                            .increasedCost
                                        }
                                        valResult={
                                          this.state.data.aggressive
                                            .validation_summary
                                            .validation_perf_result
                                        }
                                        renderIcon={
                                          this.state.data.validationPerfType !==
                                            null &&
                                          this.state.data.validationPerfType ===
                                            "Aggressive" &&
                                          this.state.data.bvmState !==
                                            "VALIDATING"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                            <Collapse
                              isOpen={this.state.collapse.includes("5")}
                              className="collapseTransition"
                            >
                              <Card style={{ border: "none" }}>
                                <CardBody style={{ border: "none" }}>
                                  <div>
                                    <ValidationDetailsTable
                                      data={this.state.data.validationData}
                                      isValidationGraphTable={false}
                                      valSummary={
                                        this.state.data.aggressive
                                          .validation_summary
                                      }
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        ) : null}

                        {/* Resizing Status */}
                        {this.state.recommendationData.aggressive !==
                          undefined &&
                        this.state.recommendationData.aggressive
                          .isRecommendationSelected === true ? (
                          <div id="tab6">
                            <div
                              onClick={() => {
                                this.toggleCollapse("6");
                              }}
                              className="collapsediv"
                            >
                              <div id="collapse_head">
                                <div className="arrow">
                                  {!this.state.collapse.includes("6")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div id="overViewCollapseTitle">
                                  Resizing Status :{" "}
                                  <div
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {this.state.recommendationData.bvmState}{" "}
                                    {this.state.recommendationData.bvmState ===
                                    "OPTIMIZING" ? (
                                      <i
                                        style={{ margin: "auto 14px" }}
                                        className="fa fa-info-circle"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="left"
                                        title="When manual resizing has been completed, please mark it as complete using Manage VMs page"
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("6") &&
                              this.state.aggrIcondataStatus.length > 0 ? (
                                <div className="maindiv">
                                  <ColorComponent
                                    data={this.state.aggrIcondataStatus[0].cpu}
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    showCostPerfMarker={true}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  {this.state.entityType === "db" ? (
                                    <ColorComponent
                                      data={
                                        this.state.aggrIcondataStatus[0].disks
                                      }
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  ) : null}
                                  <ColorComponent
                                    data={
                                      this.state.aggrIcondataStatus[0].memory
                                    }
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    hostOnly={hostOnly}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  <ColorComponent
                                    data={
                                      this.state.aggrIcondataStatus[0].network
                                    }
                                    isResize={true}
                                    isLine={
                                      this.state.entityType === "db"
                                        ? false
                                        : true
                                    }
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  {this.state.entityType !== "db" ? (
                                    <ColorComponent
                                      data={
                                        this.state.aggrIcondataStatus[0].disks
                                      }
                                      isResize={true}
                                      isLine={false}
                                      showInfo={false}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                            {this.state.aggrIcondataStatus.length > 0 ? (
                              <Collapse
                                isOpen={this.state.collapse.includes("6")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <Recommendstatus
                                      data={
                                        this.state.recommendationData.aggressive
                                      }
                                      iconData={this.state.aggrIcondataStatus}
                                      isResize={true}
                                      isLine={true}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      providerName={this.state.providerName}
                                      type="recommendation"
                                    ></Recommendstatus>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            ) : null}
                          </div>
                        ) : null}
                      </TabPane>
                      <TabPane tabId="2">
                        <div id="tab7">
                          <div
                            color="primary"
                            onClick={() => {
                              this.toggleCollapse("7");
                            }}
                            className="collapsediv"
                          >
                            <div id="collapse_head">
                              <div className="arrow">
                                {!this.state.collapse.includes("7")
                                  ? CLOSE
                                  : OPEN}{" "}
                              </div>
                              <div id="overViewCollapseTitle">
                                Rightsizing Analysis
                              </div>
                            </div>{" "}
                            {!this.state.collapse.includes("7") ? (
                              <div className="maindiv">
                                {this.state.balIcondata[0].gpu &&
                                  this.state.balIcondata[0].gpu.length > 0 && (
                                    <ColorComponent
                                      data={this.state.balIcondata[0].gpu}
                                      isResize={false}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                  )}
                                {this.state.balIcondata[0].gpumemory &&
                                  this.state.balIcondata[0].gpumemory.length >
                                    0 && (
                                    <ColorComponent
                                      data={this.state.balIcondata[0].gpumemory}
                                      isResize={false}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      // showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="gpumemory"
                                    ></ColorComponent>
                                  )}
                                <ColorComponent
                                  data={this.state.balIcondata[0].cpu}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  showCostPerfMarker={
                                    this.state.balIcondata[0].gpu &&
                                    this.state.balIcondata[0].gpu.length > 0
                                      ? false
                                      : true
                                  }
                                  fromOverview={true}
                                ></ColorComponent>
                                {this.state.entityType === "db" ? (
                                  <ColorComponent
                                    data={this.state.balIcondata[0].disks}
                                    isResize={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                  ></ColorComponent>
                                ) : null}
                                <ColorComponent
                                  data={this.state.balIcondata[0].memory}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  hostOnly={hostOnly}
                                  fromOverview={true}
                                ></ColorComponent>
                                <ColorComponent
                                  data={this.state.balIcondata[0].network}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  fromOverview={true}
                                ></ColorComponent>
                                {this.state.entityType !== "db" ? (
                                  <ColorComponent
                                    data={this.state.balIcondata[0].disks}
                                    isResize={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                  ></ColorComponent>
                                ) : null}
                              </div>
                            ) : null}{" "}
                          </div>
                          <Collapse
                            isOpen={this.state.collapse.includes("7")}
                            className="collapseTransition"
                          >
                            <Card style={{ border: "none" }}>
                              <CardBody style={{ border: "none" }}>
                                <Row>
                                  <Col sm="9">
                                    <Health
                                      data={this.state.data.balanced}
                                      iconData={this.state.balIcondata}
                                      isResize={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      providerName={this.state.providerName}
                                    ></Health>
                                  </Col>
                                  <Col
                                    sm="3"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      marginTop: "220px",
                                      marginBottom: "auto",
                                    }}
                                  >
                                    <Button
                                      className="btn-common"
                                      onClick={() => {
                                        this.showCostHealthModal("bal");
                                      }}
                                    >
                                      Show Analysis Details
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Collapse>
                        </div>
                        <div id="tab8">
                          <div
                            color="primary"
                            onClick={() => {
                              this.toggleCollapse("8");
                              this.setState({
                                activeTabRecommentionsBalanced: 1,
                              });
                            }}
                            className="collapsediv"
                          >
                            <div id="collapse_head">
                              <div className="arrow">
                                {!this.state.collapse.includes("8")
                                  ? CLOSE
                                  : OPEN}{" "}
                              </div>{" "}
                              <div id="overViewCollapseTitle">
                                Rightsizing Recommendation(s)
                              </div>
                            </div>{" "}
                            {!this.state.collapse.includes("8") ? (
                              <div className="maindiv">
                                {this.state.balIcondata[0].gpu &&
                                  this.state.balIcondata[0].gpu.length > 0 && (
                                    <ColorComponent
                                      data={this.state.balIcondata[0].gpu}
                                      isResize={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  )}
                                {this.state.balIcondata[0].gpumemory &&
                                  this.state.balIcondata[0].gpumemory.length >
                                    0 && (
                                    <ColorComponent
                                      data={this.state.balIcondata[0].gpumemory}
                                      isResize={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      // showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  )}
                                <ColorComponent
                                  data={this.state.balIcondata[0].cpu}
                                  isResize={true}
                                  showInfo={false}
                                  isLine={true}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  showCostPerfMarker={
                                    this.state.balIcondata[0].gpu &&
                                    this.state.balIcondata[0].gpu.length > 0
                                      ? false
                                      : true
                                  }
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                {this.state.entityType === "db" ? (
                                  <ColorComponent
                                    data={this.state.balIcondata[0].disks}
                                    isResize={true}
                                    showInfo={false}
                                    isLine={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                ) : null}
                                <ColorComponent
                                  data={this.state.balIcondata[0].memory}
                                  isResize={true}
                                  showInfo={false}
                                  isLine={true}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  hostOnly={hostOnly}
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                <ColorComponent
                                  data={this.state.balIcondata[0].network}
                                  isResize={true}
                                  showInfo={false}
                                  isLine={
                                    this.state.entityType === "db"
                                      ? false
                                      : true
                                  }
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                {this.state.entityType !== "db" ? (
                                  <ColorComponent
                                    data={this.state.balIcondata[0].disks}
                                    isResize={true}
                                    showInfo={false}
                                    isLine={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                ) : null}
                              </div>
                            ) : (
                              <>
                                <Container
                                  fluid
                                  style={{
                                    position: "relative",
                                    bottom: "-22px",
                                  }}
                                >
                                  <Row className="justify-content-flex-start d-flex align-items-stretch">
                                    {this.state.data.balanced.vm.map(
                                      (item, index) => {
                                        const foundDisk =
                                          this.state.data.balanced?.osdisk &&
                                          Array.isArray(
                                            this.state.data.balanced.osdisk
                                          )
                                            ? this.state.data.balanced.osdisk.find(
                                                (disk) =>
                                                  disk.recommendationChoiceNum ===
                                                  item?.recommendationChoiceNum
                                              )
                                            : null;

                                        var current_os_disk_name =
                                          foundDisk?.recommended_os_disk_name +
                                          "-" +
                                          foundDisk?.recommended_os_disk_memory;

                                        const dataDisk =
                                          Object.values(
                                            this.state.data.balanced
                                              ?.dataDisk || {}
                                          )
                                            .flat()
                                            .filter(
                                              (disk) =>
                                                disk.recommendationChoiceNum ===
                                                item?.recommendationChoiceNum
                                            )
                                            .map(
                                              (disk) =>
                                                `${disk.recommended_data_disk_name}-${disk.recommended_data_disk_memory}`
                                            )
                                            .join(", ") || "";

                                        return (
                                          <Col
                                            key={index}
                                            md="3"
                                            className={`text-center d-flex align-items-center justify-content-center recommendation-card-box ${
                                              this.state
                                                .activeTabRecommentionsBalanced ===
                                              item?.recommendationChoiceNum + 1
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (
                                                !this.state.collapse.includes(
                                                  "8"
                                                )
                                              ) {
                                                this.toggleCollapse("8");
                                              }
                                              this.toggleTabRecommentions(
                                                item?.recommendationChoiceNum +
                                                  1,
                                                "Balanced"
                                              );
                                            }}
                                          >
                                            <div style={{ padding: "7px 0px" }}>
                                              <h6 className="fw-bold">
                                                {item?.recommendationChoiceNum ===
                                                0
                                                  ? "Default Recommendation"
                                                  : "Alternate " +
                                                    item?.recommendationChoiceNum +
                                                    " Recommendation"}
                                              </h6>
                                              <div className="fw-bold">
                                                {`(${
                                                  item.recommended_vmsize_name
                                                }, (${current_os_disk_name}${
                                                  dataDisk
                                                    ? `, ${dataDisk})`
                                                    : ")"
                                                })`}
                                              </div>
                                            </div>
                                          </Col>
                                        );
                                      }
                                    )}
                                  </Row>
                                </Container>
                              </>
                            )}{" "}
                          </div>
                          <Collapse
                            isOpen={this.state.collapse.includes("8")}
                            className="collapseTransition"
                          >
                            <TabContent
                              activeTab={
                                this.state.activeTabRecommentionsBalanced
                              }
                            >
                              {this.state.data.balanced.vm.map(
                                (item, index) => (
                                  <>
                                    <TabPane
                                      key={index + 1}
                                      tabId={
                                        (item?.recommendationChoiceNum || 0) + 1
                                      }
                                    >
                                      <Card style={{ border: "none" }}>
                                        <CardBody style={{ border: "none" }}>
                                          <Recommend
                                            data={this.state.data.balanced}
                                            iconData={this.state.balIcondata}
                                            isResize={true}
                                            isLine={true}
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                            userCurrency={
                                              this.state.data?.userCurrency
                                            }
                                            providerName={
                                              this.state.providerName
                                            }
                                            type="recommendation"
                                            tabID={
                                              item?.recommendationChoiceNum || 0
                                            }
                                          ></Recommend>
                                        </CardBody>
                                      </Card>

                                      <div
                                        id="tab2-2-Benefits"
                                        color="primary"
                                        onClick={() => {
                                          this.toggleCollapse("2-2-Benefits");
                                        }}
                                        className="collapsediv"
                                      >
                                        <div id="collapse_head">
                                          <div className="arrow">
                                            {!this.state.collapse.includes(
                                              "2-2-Benefits"
                                            )
                                              ? CLOSE
                                              : OPEN}
                                          </div>
                                          <div id="overViewCollapseTitle">
                                            Benefits and Drawbacks
                                            {item?.recommendationChoiceNum === 0
                                              ? ""
                                              : " (Alternate " +
                                                item?.recommendationChoiceNum +
                                                " Recommendation)"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Inner Collapse */}
                                      <Collapse
                                        isOpen={this.state.collapse.includes(
                                          "2-2-Benefits"
                                        )}
                                        className="collapseTransition"
                                      >
                                        <div
                                          className="overviewTextCompParent"
                                          style={{ paddingLeft: "20px" }}
                                        >
                                          {this.state.data.balanced
                                            ?.summaryList &&
                                            this.state.data.balanced.summaryList
                                              .filter(
                                                (itemCost) =>
                                                  itemCost.recommendationChoiceNum ===
                                                  item.recommendationChoiceNum
                                              )
                                              .map(
                                                (filteredItem, index) =>
                                                  filteredItem.costSummaryText !==
                                                    undefined &&
                                                  filteredItem.costSummaryText !==
                                                    null && (
                                                    <div
                                                      key={index}
                                                      className="maindiv-text-overview maindiv-text-overview-grad"
                                                    >
                                                      <div className="expected-cost-title">
                                                        Expected Cost Effect
                                                      </div>
                                                      <ResingBenefitTextComponent
                                                        title={
                                                          filteredItem.costSummaryText
                                                        }
                                                        data={
                                                          filteredItem.costSummaryDescription
                                                        }
                                                        isAsp={this.state.isAsp}
                                                        entityType={
                                                          this.state.entityType
                                                        }
                                                      />
                                                    </div>
                                                  )
                                              )}

                                          {this.state.data.balanced
                                            ?.summaryList &&
                                            this.state.data.balanced.summaryList
                                              .filter(
                                                (itemPerformance) =>
                                                  item.recommendationChoiceNum ===
                                                  itemPerformance.recommendationChoiceNum
                                              )
                                              .map(
                                                (filteredItem, index) =>
                                                  filteredItem.perfSummaryText !==
                                                    undefined &&
                                                  filteredItem.perfSummaryText !==
                                                    null && (
                                                    <div
                                                      key={index}
                                                      className="maindiv-text-overview maindiv-text-overview-grad"
                                                    >
                                                      <div className="expected-cost-title">
                                                        Expected Performance
                                                        Effect
                                                      </div>
                                                      <ResingBenefitTextComponent
                                                        title={
                                                          filteredItem.perfSummaryText
                                                        }
                                                        data={
                                                          filteredItem.perfSummaryDescription
                                                        }
                                                        isAsp={this.state.isAsp}
                                                        entityType={
                                                          this.state.entityType
                                                        }
                                                      />
                                                    </div>
                                                  )
                                              )}
                                        </div>
                                      </Collapse>

                                      <div
                                        id="tab2-2-insights"
                                        color="primary"
                                        onClick={() => {
                                          this.toggleCollapse("2-2-insights");
                                        }}
                                        className="collapsediv"
                                      >
                                        <div id="collapse_head">
                                          <div className="arrow">
                                            {!this.state.collapse.includes(
                                              "2-2-insights"
                                            )
                                              ? CLOSE
                                              : OPEN}
                                          </div>
                                          <div id="overViewCollapseTitle">
                                            Insights and Actions{" "}
                                            {item?.recommendationChoiceNum === 0
                                              ? ""
                                              : " (Alternate " +
                                                item?.recommendationChoiceNum +
                                                " Recommendation)"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Inner Collapse */}
                                      <Collapse
                                        isOpen={this.state.collapse.includes(
                                          "2-2-insights"
                                        )}
                                        className="collapseTransition"
                                      >
                                        <div
                                          className="overviewTextCompParent"
                                          style={{ paddingLeft: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              flexDirection: item?.rf_goal_plot
                                                ? "column"
                                                : "row",
                                            }}
                                            className="maindiv-text-overview"
                                          >
                                            {item.gaiInsightSummary !==
                                              undefined &&
                                              item.gaiInsightSummary !==
                                                null && (
                                                <div
                                                  className="maindiv-text-summary-grad mb-5 pr-2"
                                                  key={index}
                                                  style={{
                                                    width: item?.rf_goal_plot
                                                      ? "unset"
                                                      : "50%",
                                                  }}
                                                >
                                                  <div className="expected-cost-title">
                                                    AI Insights
                                                  </div>
                                                  <ResingBenefitTextComponent
                                                    title={
                                                      item.gaiInsightSummary
                                                    }
                                                    data={[
                                                      item.gaiInsightDescription,
                                                    ]}
                                                    isAsp={this.state.isAsp}
                                                    entityType={
                                                      this.state.entityType
                                                    }
                                                  />
                                                </div>
                                              )}

                                            <div
                                              className="maindiv-text-summary-grad"
                                              style={{
                                                width: item?.rf_goal_plot
                                                  ? "unset"
                                                  : "50%",
                                              }}
                                            >
                                              <div className="expected-cost-title mb-2">
                                                Actions
                                              </div>
                                              <ul style={{ textAlign: "left" }}>
                                                {item?.recommendationActions?.map(
                                                  (action, index) => (
                                                    <React.Fragment key={index}>
                                                      <li key={index}>
                                                        {action}
                                                      </li>
                                                    </React.Fragment>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>

                                          {item.rf_goal_plot !== undefined &&
                                          item.rf_goal_plot !== null ? (
                                            <React.Fragment key={index}>
                                              <div>
                                                <div className="expected-cost-title mb-2">
                                                  Visual Insight
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                  }}
                                                >
                                                  <div
                                                    className="svg-container"
                                                    style={{ width: "unset" }}
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        item?.rf_goal_plot,
                                                    }}
                                                  />
                                                  <div
                                                    className="svg-view-icon"
                                                    style={{
                                                      position: "relative",
                                                      right: 40,
                                                      top: 5,
                                                    }}
                                                    title="Open image in new tab"
                                                    onClick={() =>
                                                      this.openSvgInNewTab(
                                                        item?.rf_goal_plot
                                                      )
                                                    }
                                                  >
                                                    <FaSearchPlus size={24} />
                                                  </div>
                                                </div>
                                              </div>
                                            </React.Fragment>
                                          ) : null}
                                        </div>
                                      </Collapse>
                                    </TabPane>
                                  </>
                                )
                              )}
                            </TabContent>

                            {/* <div
                              className="overviewTextCompParent"
                              style={{ paddingLeft: "20px" }}
                            >
                              {this.state.data.balanced?.summaryList &&
                                this.state.data.balanced.summaryList
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsBalanced - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.costSummaryText !==
                                        undefined &&
                                      filteredItem.costSummaryText !== null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            Expected Cost Effect
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={filteredItem.costSummaryText}
                                            data={
                                              filteredItem.costSummaryDescription
                                            }
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}

                              {this.state.data.balanced?.summaryList &&
                                this.state.data.balanced.summaryList
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsBalanced - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.perfSummaryText !==
                                        undefined &&
                                      filteredItem.perfSummaryText !== null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            Expected Performance Effect
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={filteredItem.perfSummaryText}
                                            data={
                                              filteredItem.perfSummaryDescription
                                            }
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}

                              {this.state.data.balanced?.vm &&
                                this.state.data.balanced.vm
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsBalanced - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.gaiInsightSummary !==
                                        undefined &&
                                      filteredItem.gaiInsightSummary !==
                                        null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            AI Insights
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={
                                              filteredItem.gaiInsightSummary
                                            }
                                            data={[
                                              filteredItem.gaiInsightDescription,
                                            ]}
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}
                            </div>

                            {this.state.data.balanced?.vm &&
                              this.state.data.balanced.vm
                                .filter(
                                  (item) =>
                                    item.rf_goal_plot !== undefined &&
                                    item.rf_goal_plot !== null &&
                                    item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEconomical - 1
                                      )
                                )
                                .map(
                                  (filteredItem, index) =>
                                    filteredItem.gaiInsightSummary !==
                                      undefined &&
                                    filteredItem.gaiInsightSummary !== null && (
                                      <React.Fragment key={index}>
                                        <hr
                                          style={{
                                            width: "98%",
                                            height: "10px",
                                          }}
                                        />
                                        <h6>
                                          {filteredItem?.recommendationChoiceNum ===
                                          0
                                            ? "Resource Fit Graph"
                                            : "Alternate " +
                                              filteredItem?.recommendationChoiceNum +
                                              " Recommendation Resource Fit Graph"}
                                        </h6>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "100%",
                                          }}
                                          className="svg-container"
                                          onClick={() =>
                                            this.openSvgInNewTab(
                                              filteredItem?.rf_goal_plot
                                            )
                                          }
                                          dangerouslySetInnerHTML={{
                                            __html: filteredItem?.rf_goal_plot,
                                          }}
                                        />
                                      </React.Fragment>
                                    )
                                )} */}
                          </Collapse>
                        </div>

                        {this.state.data &&
                        this.state.data.gaiValidationData &&
                        this.state.data.gaiValidationData.validationPerfType ===
                          "Balanced" ? (
                          <>
                            <div id="tab21">
                              <div
                                color="primary"
                                onClick={() => {
                                  this.toggleCollapse("21");
                                }}
                                className="collapsediv"
                              >
                                <div id="collapse_head">
                                  <div className="arrow">
                                    {!this.state.collapse.includes("21")
                                      ? CLOSE
                                      : OPEN}{" "}
                                  </div>{" "}
                                  <div id="overViewCollapseTitle">
                                    GAI Recommendation
                                  </div>
                                </div>{" "}
                                {!this.state.collapse.includes("21") ? (
                                  <div className="maindiv">
                                    <ColorComponent
                                      data={this.state.balIcondata[0].cpu}
                                      isResize={true}
                                      showInfo={false}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType === "db" ? (
                                      <ColorComponent
                                        data={this.state.balIcondata[0].disks}
                                        isResize={true}
                                        showInfo={false}
                                        isLine={true}
                                        isAsp={this.state.isAsp}
                                        entityType={this.state.entityType}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                    <ColorComponent
                                      data={this.state.balIcondata[0].memory}
                                      isResize={true}
                                      showInfo={false}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      hostOnly={hostOnly}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    <ColorComponent
                                      data={this.state.balIcondata[0].network}
                                      isResize={true}
                                      showInfo={false}
                                      isLine={
                                        this.state.entityType === "db"
                                          ? false
                                          : true
                                      }
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType !== "db" ? (
                                      <ColorComponent
                                        data={this.state.balIcondata[0].disks}
                                        isResize={true}
                                        showInfo={false}
                                        isLine={false}
                                        isAsp={this.state.isAsp}
                                        entityType={this.state.entityType}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                  </div>
                                ) : null}{" "}
                              </div>
                              <Collapse
                                isOpen={this.state.collapse.includes("21")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <GaiRecommend
                                      data={this.state.data.gaiValidationData}
                                      iconData={this.state.balIcondata}
                                      isResize={true}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      userCurrency={
                                        this.state.data?.userCurrency
                                      }
                                      providerName={this.state.providerName}
                                    ></GaiRecommend>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </div>
                            <div id="tab22">
                              <div
                                color="primary"
                                onClick={() => {
                                  this.toggleCollapse("22");
                                }}
                                className="collapsediv resize-collapsediv"
                              >
                                <div
                                  id="collapse_head"
                                  style={{
                                    minHeight: "102px",
                                    maxWidth: "28%",
                                  }}
                                >
                                  <div className="arrow">
                                    {!this.state.collapse.includes("22")
                                      ? CLOSE
                                      : OPEN}
                                  </div>
                                  <div id="overViewCollapseTitle">
                                    Expected Benefits & Drawbacks of GAI
                                    Recommendation
                                  </div>
                                </div>{" "}
                                {!this.state.collapse.includes("22") ? (
                                  <div className="overviewTextCompParent">
                                    {this.state.data.gaiValidationData !==
                                      undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .costSummaryText !== undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .costSummaryText !== null ? (
                                      <div className="maindiv-text-overview maindiv-text-overview-grad">
                                        <ResingBenefitTextComponent
                                          title={
                                            this.state.data.gaiValidationData
                                              .summary.costSummaryText
                                          }
                                          data={
                                            this.state.data.gaiValidationData
                                              .summary.costSummaryDescription
                                          }
                                          isAsp={this.state.isAsp}
                                          entityType={this.state.entityType}
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {this.state.data.gaiValidationData !==
                                      undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .perfSummaryText !== undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .perfSummaryText !== null ? (
                                      <div className="maindiv-text-overview maindiv-text-overview-grad">
                                        <ResingBenefitTextComponent
                                          data={
                                            this.state.data.gaiValidationData
                                              .summary.perfSummaryDescription
                                          }
                                          title={
                                            this.state.data.gaiValidationData
                                              .summary.perfSummaryText
                                          }
                                          isAsp={this.state.isAsp}
                                          entityType={this.state.entityType}
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ) : null}
                              </div>
                              <Collapse
                                isOpen={this.state.collapse.includes("22")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <GaiResize
                                      data={this.state.data.gaiValidationData}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      userCurrency={
                                        this.state.data?.userCurrency
                                      }
                                      providerName={this.state.providerName}
                                    ></GaiResize>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </div>
                          </>
                        ) : null}
                        {this.state.isValidationGraphTable === false &&
                        this.state.data.validationData !== null &&
                        this.state.data.validationData !== undefined &&
                        this.state.data.validationData.perfType ===
                          "Balanced" ? (
                          <div id="tab10">
                            <div
                              onClick={() => {
                                this.toggleCollapse("10");
                              }}
                              className="collapsediv"
                            >
                              <div id="collapse_head">
                                <div className="arrow">
                                  {!this.state.collapse.includes("10")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div>
                                  <div id="overViewCollapseTitle">
                                    Validation :
                                  </div>
                                  <div>
                                    <b>Balanced</b>
                                  </div>
                                  <div>{bvmStatus}</div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("10") ? (
                                this.state.balIcondata.length > 0 ? (
                                  <div className="maindiv">
                                    <ColorComponent
                                      data={this.state.balIcondata[0].cpu}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Balanced"
                                      valData={this.state.data.validationData}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType === "db" ? (
                                      <ColorComponent
                                        data={this.state.balIcondata[0].disks}
                                        isResize={true}
                                        isLine={true}
                                        showInfo={false}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        forValidation={true}
                                        valObjective="Balanced"
                                        valData={this.state.data.validationData}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                    <ColorComponent
                                      data={this.state.balIcondata[0].memory}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Balanced"
                                      valData={this.state.data.validationData}
                                      hostOnly={hostOnly}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    <ColorComponent
                                      data={this.state.balIcondata[0].network}
                                      isResize={true}
                                      isLine={
                                        this.state.entityType === "db"
                                          ? false
                                          : true
                                      }
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Balanced"
                                      valData={this.state.data.validationData}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType !== "db" ? (
                                      <ColorComponent
                                        data={this.state.balIcondata[0].disks}
                                        isResize={true}
                                        isLine={false}
                                        showInfo={false}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        forValidation={true}
                                        valObjective="Balanced"
                                        valData={this.state.data.validationData}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                  </div>
                                ) : null
                              ) : null}
                            </div>
                            {this.state.data.validationData.perfType ===
                            "Balanced" ? (
                              <Collapse
                                isOpen={this.state.collapse.includes("10")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <div>
                                      <ValidationTable
                                        data={
                                          this.state.recommendationData.balanced
                                        }
                                        valTableData={
                                          this.state.data.validationData
                                        }
                                        iconData={this.state.balIcondata}
                                        isResize={true}
                                        isLine={true}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        valObjective="Balanced"
                                        showValidationDetails={
                                          this.showValidationDetails
                                        }
                                      ></ValidationTable>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            ) : null}
                          </div>
                        ) : null}
                        {this.state.isValidationGraphTable === false &&
                        this.state.data.validationData !== null &&
                        this.state.data.validationData !== undefined &&
                        this.state.data.validationData.perfType ===
                          "Balanced" &&
                        bvmStatus === "VALIDATED" ? (
                          <div id="tab11">
                            <div
                              onClick={() => {
                                this.toggleCollapse("11");
                              }}
                              className="collapsediv"
                            >
                              <div
                                id="collapse_head"
                                style={{ maxWidth: "29%" }}
                              >
                                <div className="arrow">
                                  {!this.state.collapse.includes("11")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div>
                                  <div id="overViewCollapseTitle">
                                    Validated Benefits & Drawbacks of
                                    Recommendation :{" "}
                                  </div>
                                  <div>
                                    <b>Balanced</b>
                                  </div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("11") ? (
                                <div className="overviewTextCompParent">
                                  {this.state.data.balanced !== undefined &&
                                  this.state.data.balanced.validation_summary
                                    .costSummaryText !== undefined &&
                                  this.state.data.balanced.validation_summary
                                    .costSummaryText !== null ? (
                                    <div className="maindiv-text-overview maindiv-text-overview-grad">
                                      <ResingBenefitTextComponent
                                        title={
                                          this.state.data.balanced
                                            .validation_summary.costSummaryText
                                        }
                                        data={
                                          this.state.data.balanced
                                            .validation_summary
                                            .costSummaryDescription
                                        }
                                        affectString={
                                          this.state.data.balanced
                                            .validation_summary.perfAffected
                                        }
                                        valResult={
                                          this.state.data.balanced
                                            .validation_summary
                                            .validation_cost_result
                                        }
                                        renderIcon={
                                          this.state.data.validationPerfType !==
                                            null &&
                                          this.state.data.validationPerfType ===
                                            "Balanced" &&
                                          this.state.data.bvmState !==
                                            "VALIDATING"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                  {this.state.data.balanced !== undefined &&
                                  this.state.data.balanced.validation_summary
                                    .perfSummaryText !== undefined &&
                                  this.state.data.balanced.validation_summary
                                    .perfSummaryText !== null ? (
                                    <div className="maindiv-text-overview maindiv-text-overview-grad">
                                      <ResingBenefitTextComponent
                                        data={
                                          this.state.data.balanced
                                            .validation_summary
                                            .perfSummaryDescription
                                        }
                                        title={
                                          this.state.data.balanced
                                            .validation_summary.perfSummaryText
                                        }
                                        affectString={
                                          this.state.data.balanced.summary
                                            .increasedCost
                                        }
                                        valResult={
                                          this.state.data.balanced
                                            .validation_summary
                                            .validation_perf_result
                                        }
                                        renderIcon={
                                          this.state.data.validationPerfType !==
                                            null &&
                                          this.state.data.validationPerfType ===
                                            "Balanced" &&
                                          this.state.data.bvmState !==
                                            "VALIDATING"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                            <Collapse
                              isOpen={this.state.collapse.includes("11")}
                              className="collapseTransition"
                            >
                              <Card style={{ border: "none" }}>
                                <CardBody style={{ border: "none" }}>
                                  <div>
                                    <ValidationDetailsTable
                                      data={this.state.data.validationData}
                                      isValidationGraphTable={false}
                                      valSummary={
                                        this.state.data.balanced
                                          .validation_summary
                                      }
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        ) : null}
                        {this.state.recommendationData.balanced !== undefined &&
                        this.state.recommendationData.balanced
                          .isRecommendationSelected === true ? (
                          <div id="tab12">
                            <div
                              onClick={() => {
                                this.toggleCollapse("12");
                              }}
                              className="collapsediv"
                            >
                              <div id="collapse_head">
                                <div className="arrow">
                                  {!this.state.collapse.includes("12")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div id="overViewCollapseTitle">
                                  Resizing Status :{" "}
                                  <div
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {this.state.recommendationData.bvmState}{" "}
                                    {this.state.recommendationData.bvmState ===
                                    "OPTIMIZING" ? (
                                      <i
                                        style={{ margin: "auto 14px" }}
                                        className="fa fa-info-circle"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="left"
                                        title="When manual resizing has been completed, please mark it as complete using Manage VMs page"
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("12") &&
                              this.state.balIcondataStatus.length > 0 ? (
                                <div className="maindiv">
                                  <ColorComponent
                                    data={this.state.balIcondataStatus[0].cpu}
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    showCostPerfMarker={true}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  {this.state.entityType === "db" ? (
                                    <ColorComponent
                                      data={
                                        this.state.balIcondataStatus[0].disks
                                      }
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  ) : null}
                                  <ColorComponent
                                    data={
                                      this.state.balIcondataStatus[0].memory
                                    }
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    hostOnly={hostOnly}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  <ColorComponent
                                    data={
                                      this.state.balIcondataStatus[0].network
                                    }
                                    isResize={true}
                                    isLine={
                                      this.state.entityType === "db"
                                        ? false
                                        : true
                                    }
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  {this.state.entityType !== "db" ? (
                                    <ColorComponent
                                      data={
                                        this.state.balIcondataStatus[0].disks
                                      }
                                      isResize={true}
                                      isLine={false}
                                      showInfo={false}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                            {this.state.balIcondataStatus.length > 0 ? (
                              <Collapse
                                isOpen={this.state.collapse.includes("12")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <Recommendstatus
                                      data={
                                        this.state.recommendationData.balanced
                                      }
                                      iconData={this.state.balIcondataStatus}
                                      isResize={true}
                                      isLine={true}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      providerName={this.state.providerName}
                                      type="recommendation"
                                    ></Recommendstatus>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            ) : null}
                          </div>
                        ) : null}
                      </TabPane>
                      <TabPane tabId="3">
                        <div id="tab13">
                          <div
                            color="primary"
                            onClick={() => {
                              this.toggleCollapse("13");
                            }}
                            className="collapsediv"
                          >
                            <div id="collapse_head">
                              <div className="arrow">
                                {!this.state.collapse.includes("13")
                                  ? CLOSE
                                  : OPEN}
                              </div>
                              <div id="overViewCollapseTitle">
                                Rightsizing Analysis
                              </div>
                            </div>{" "}
                            {!this.state.collapse.includes("13") ? (
                              <div className="maindiv">
                                {this.state.healthyIcondata[0].gpu &&
                                  this.state.healthyIcondata[0].gpu.length >
                                    0 && (
                                    <ColorComponent
                                      data={this.state.healthyIcondata[0].gpu}
                                      isResize={false}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                  )}

                                {this.state.healthyIcondata[0].gpumemory &&
                                  this.state.healthyIcondata[0].gpumemory
                                    .length > 0 && (
                                    <ColorComponent
                                      data={
                                        this.state.healthyIcondata[0].gpumemory
                                      }
                                      isResize={false}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      // showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                  )}

                                <ColorComponent
                                  data={this.state.healthyIcondata[0].cpu}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  showCostPerfMarker={
                                    this.state.healthyIcondata[0].gpu &&
                                    this.state.healthyIcondata[0].gpu.length > 0
                                      ? false
                                      : true
                                  }
                                  fromOverview={true}
                                ></ColorComponent>
                                {this.state.entityType === "db" ? (
                                  <ColorComponent
                                    data={this.state.healthyIcondata[0].disks}
                                    isResize={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                  ></ColorComponent>
                                ) : null}
                                <ColorComponent
                                  data={this.state.healthyIcondata[0].memory}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  hostOnly={hostOnly}
                                  fromOverview={true}
                                ></ColorComponent>
                                <ColorComponent
                                  data={this.state.healthyIcondata[0].network}
                                  isResize={false}
                                  showInfo={false}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  fromOverview={true}
                                ></ColorComponent>
                                {this.state.entityType !== "db" ? (
                                  <ColorComponent
                                    data={this.state.healthyIcondata[0].disks}
                                    isResize={false}
                                    showInfo={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                  ></ColorComponent>
                                ) : null}
                              </div>
                            ) : null}{" "}
                          </div>
                          <Collapse
                            isOpen={this.state.collapse.includes("13")}
                            className="collapseTransition"
                          >
                            <Card style={{ border: "none" }}>
                              <CardBody style={{ border: "none" }}>
                                <Row>
                                  <Col sm="9">
                                    <Health
                                      data={this.state.data.conservative}
                                      iconData={this.state.healthyIcondata}
                                      isResize={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      providerName={this.state.providerName}
                                    ></Health>
                                  </Col>
                                  <Col
                                    sm="3"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      marginTop: "220px",
                                      marginBottom: "auto",
                                    }}
                                  >
                                    <Button
                                      className="btn-common"
                                      onClick={() => {
                                        this.showCostHealthModal("health");
                                      }}
                                    >
                                      Show Analysis Details
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Collapse>
                        </div>
                        <div id="tab14">
                          <div
                            color="primary"
                            onClick={() => {
                              this.toggleCollapse("14");
                              this.setState({
                                activeTabRecommentionsEnhanced: 1,
                              });
                            }}
                            className="collapsediv"
                          >
                            <div id="collapse_head">
                              <div className="arrow">
                                {!this.state.collapse.includes("14")
                                  ? CLOSE
                                  : OPEN}
                              </div>
                              <div id="overViewCollapseTitle">
                                Rightsizing Recommendation(s)
                              </div>
                            </div>{" "}
                            {!this.state.collapse.includes("14") ? (
                              <div className="maindiv">
                                {this.state.healthyIcondata[0].gpu &&
                                  this.state.healthyIcondata[0].gpu.length >
                                    0 && (
                                    <ColorComponent
                                      data={this.state.healthyIcondata[0].gpu}
                                      isResize={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  )}

                                {this.state.healthyIcondata[0].gpumemory &&
                                  this.state.healthyIcondata[0].gpumemory
                                    .length > 0 && (
                                    <ColorComponent
                                      data={
                                        this.state.healthyIcondata[0].gpumemory
                                      }
                                      isResize={true}
                                      showInfo={false}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      // showCostPerfMarker={true}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  )}

                                <ColorComponent
                                  data={this.state.healthyIcondata[0].cpu}
                                  isResize={true}
                                  showInfo={false}
                                  isLine={true}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  showCostPerfMarker={
                                    this.state.healthyIcondata[0].gpu &&
                                    this.state.healthyIcondata[0].gpu.length > 0
                                      ? false
                                      : true
                                  }
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                {this.state.entityType === "db" ? (
                                  <ColorComponent
                                    data={this.state.healthyIcondata[0].disks}
                                    isResize={true}
                                    showInfo={false}
                                    isLine={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                ) : null}
                                <ColorComponent
                                  data={this.state.healthyIcondata[0].memory}
                                  isResize={true}
                                  showInfo={false}
                                  isLine={true}
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  hostOnly={hostOnly}
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                <ColorComponent
                                  data={this.state.healthyIcondata[0].network}
                                  isResize={true}
                                  showInfo={false}
                                  isLine={
                                    this.state.entityType === "db"
                                      ? false
                                      : true
                                  }
                                  isAsp={this.state.isAsp}
                                  entityType={this.state.entityType}
                                  fromOverview={true}
                                  type="recommendation"
                                ></ColorComponent>
                                {this.state.entityType !== "db" ? (
                                  <ColorComponent
                                    data={this.state.healthyIcondata[0].disks}
                                    isResize={true}
                                    showInfo={false}
                                    isLine={false}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                ) : null}
                              </div>
                            ) : (
                              <>
                                <Container
                                  fluid
                                  style={{
                                    position: "relative",
                                    bottom: "-22px",
                                  }}
                                >
                                  <Row className="justify-content-flex-start d-flex align-items-stretch">
                                    {this.state.data.conservative.vm.map(
                                      (item, index) => {
                                        const foundDisk =
                                          this.state.data.conservative
                                            ?.osdisk &&
                                          Array.isArray(
                                            this.state.data.conservative.osdisk
                                          )
                                            ? this.state.data.conservative.osdisk.find(
                                                (disk) =>
                                                  disk.recommendationChoiceNum ===
                                                  item?.recommendationChoiceNum
                                              )
                                            : null;

                                        var current_os_disk_name =
                                          foundDisk?.recommended_os_disk_name +
                                          "-" +
                                          foundDisk?.recommended_os_disk_memory;

                                        const dataDisk =
                                          Object.values(
                                            this.state.data.conservative
                                              ?.dataDisk || {}
                                          )
                                            .flat()
                                            .filter(
                                              (disk) =>
                                                disk.recommendationChoiceNum ===
                                                item?.recommendationChoiceNum
                                            )
                                            .map(
                                              (disk) =>
                                                `${disk.recommended_data_disk_name}-${disk.recommended_data_disk_memory}`
                                            )
                                            .join(", ") || "";

                                        return (
                                          <Col
                                            key={index}
                                            md="3"
                                            className={`text-center d-flex align-items-center justify-content-center recommendation-card-box ${
                                              this.state
                                                .activeTabRecommentionsEnhanced ===
                                              item?.recommendationChoiceNum + 1
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (
                                                !this.state.collapse.includes(
                                                  "14"
                                                )
                                              ) {
                                                this.toggleCollapse("14");
                                              }
                                              this.toggleTabRecommentions(
                                                item?.recommendationChoiceNum +
                                                  1,
                                                "Enhanced"
                                              );
                                            }}
                                          >
                                            <div style={{ padding: "7px 0px" }}>
                                              <h6 className="fw-bold">
                                                {item?.recommendationChoiceNum ===
                                                0
                                                  ? "Default Recommendation"
                                                  : "Alternate " +
                                                    item?.recommendationChoiceNum +
                                                    " Recommendation"}
                                              </h6>
                                              <div className="fw-bold">
                                                {`(${
                                                  item.recommended_vmsize_name
                                                }, (${current_os_disk_name}${
                                                  dataDisk
                                                    ? `, ${dataDisk})`
                                                    : ")"
                                                })`}
                                              </div>
                                            </div>
                                          </Col>
                                        );
                                      }
                                    )}
                                  </Row>
                                </Container>
                              </>
                            )}{" "}
                          </div>
                          <Collapse
                            isOpen={this.state.collapse.includes("14")}
                            className="collapseTransition"
                          >
                            <TabContent
                              activeTab={
                                this.state.activeTabRecommentionsEnhanced
                              }
                            >
                              {this.state.data.conservative.vm.map(
                                (item, index) => (
                                  <>
                                    <TabPane
                                      key={item + 1}
                                      tabId={
                                        (item?.recommendationChoiceNum || 0) + 1
                                      }
                                    >
                                      <Card style={{ border: "none" }}>
                                        <CardBody style={{ border: "none" }}>
                                          <Recommend
                                            data={this.state.data.conservative}
                                            iconData={
                                              this.state.healthyIcondata
                                            }
                                            isResize={true}
                                            isLine={true}
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                            userCurrency={
                                              this.state.data?.userCurrency
                                            }
                                            providerName={
                                              this.state.providerName
                                            }
                                            type="recommendation"
                                            tabID={
                                              item?.recommendationChoiceNum || 0
                                            }
                                          ></Recommend>
                                        </CardBody>
                                      </Card>

                                      <div
                                        id="tab3-2-Benefits"
                                        color="primary"
                                        onClick={() => {
                                          this.toggleCollapse("3-2-Benefits");
                                        }}
                                        className="collapsediv"
                                      >
                                        <div id="collapse_head">
                                          <div className="arrow">
                                            {!this.state.collapse.includes(
                                              "3-2-Benefits"
                                            )
                                              ? CLOSE
                                              : OPEN}
                                          </div>
                                          <div id="overViewCollapseTitle">
                                            Benefits and Drawbacks
                                            {item?.recommendationChoiceNum === 0
                                              ? ""
                                              : " (Alternate " +
                                                item?.recommendationChoiceNum +
                                                " Recommendation)"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Inner Collapse */}
                                      <Collapse
                                        isOpen={this.state.collapse.includes(
                                          "3-2-Benefits"
                                        )}
                                        className="collapseTransition"
                                      >
                                        <div
                                          className="overviewTextCompParent"
                                          style={{ paddingLeft: "20px" }}
                                        >
                                          {this.state.data.conservative
                                            ?.summaryList &&
                                            this.state.data.conservative.summaryList
                                              .filter(
                                                (itemCost) =>
                                                  itemCost.recommendationChoiceNum ===
                                                  item.recommendationChoiceNum
                                              )
                                              .map(
                                                (filteredItem, index) =>
                                                  filteredItem.costSummaryText !==
                                                    undefined &&
                                                  filteredItem.costSummaryText !==
                                                    null && (
                                                    <div
                                                      key={index}
                                                      className="maindiv-text-overview maindiv-text-overview-grad"
                                                    >
                                                      <div className="expected-cost-title">
                                                        Expected Cost Effect
                                                      </div>
                                                      <ResingBenefitTextComponent
                                                        title={
                                                          filteredItem.costSummaryText
                                                        }
                                                        data={
                                                          filteredItem.costSummaryDescription
                                                        }
                                                        isAsp={this.state.isAsp}
                                                        entityType={
                                                          this.state.entityType
                                                        }
                                                      />
                                                    </div>
                                                  )
                                              )}

                                          {this.state.data.conservative
                                            ?.summaryList &&
                                            this.state.data.conservative.summaryList
                                              .filter(
                                                (itemPerformance) =>
                                                  item.recommendationChoiceNum ===
                                                  itemPerformance.recommendationChoiceNum
                                              )
                                              .map(
                                                (filteredItem, index) =>
                                                  filteredItem.perfSummaryText !==
                                                    undefined &&
                                                  filteredItem.perfSummaryText !==
                                                    null && (
                                                    <div
                                                      key={index}
                                                      className="maindiv-text-overview maindiv-text-overview-grad"
                                                    >
                                                      <div className="expected-cost-title">
                                                        Expected Performance
                                                        Effect
                                                      </div>
                                                      <ResingBenefitTextComponent
                                                        title={
                                                          filteredItem.perfSummaryText
                                                        }
                                                        data={
                                                          filteredItem.perfSummaryDescription
                                                        }
                                                        isAsp={this.state.isAsp}
                                                        entityType={
                                                          this.state.entityType
                                                        }
                                                      />
                                                    </div>
                                                  )
                                              )}
                                        </div>
                                      </Collapse>

                                      <div
                                        id="tab3-2-insights"
                                        color="primary"
                                        onClick={() => {
                                          this.toggleCollapse("3-2-insights");
                                        }}
                                        className="collapsediv"
                                      >
                                        <div id="collapse_head">
                                          <div className="arrow">
                                            {!this.state.collapse.includes(
                                              "3-2-insights"
                                            )
                                              ? CLOSE
                                              : OPEN}
                                          </div>
                                          <div id="overViewCollapseTitle">
                                            Insights and Actions{" "}
                                            {item?.recommendationChoiceNum === 0
                                              ? ""
                                              : " (Alternate " +
                                                item?.recommendationChoiceNum +
                                                " Recommendation)"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Inner Collapse */}
                                      <Collapse
                                        isOpen={this.state.collapse.includes(
                                          "3-2-insights"
                                        )}
                                        className="collapseTransition"
                                      >
                                        <div
                                          className="overviewTextCompParent"
                                          style={{ paddingLeft: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              flexDirection: item?.rf_goal_plot
                                                ? "column"
                                                : "row",
                                            }}
                                            className="maindiv-text-overview"
                                          >
                                            {item.gaiInsightSummary !==
                                              undefined &&
                                              item.gaiInsightSummary !==
                                                null && (
                                                <div
                                                  className="maindiv-text-summary-grad mb-5 pr-2"
                                                  key={index}
                                                  style={{
                                                    width: item?.rf_goal_plot
                                                      ? "unset"
                                                      : "50%",
                                                  }}
                                                >
                                                  <div className="expected-cost-title">
                                                    AI Insights
                                                  </div>
                                                  <ResingBenefitTextComponent
                                                    title={
                                                      item.gaiInsightSummary
                                                    }
                                                    data={[
                                                      item.gaiInsightDescription,
                                                    ]}
                                                    isAsp={this.state.isAsp}
                                                    entityType={
                                                      this.state.entityType
                                                    }
                                                  />
                                                </div>
                                              )}

                                            <div
                                              className="maindiv-text-summary-grad"
                                              style={{
                                                width: item?.rf_goal_plot
                                                  ? "unset"
                                                  : "50%",
                                              }}
                                            >
                                              <div className="expected-cost-title mb-2">
                                                Actions
                                              </div>
                                              <ul style={{ textAlign: "left" }}>
                                                {item?.recommendationActions?.map(
                                                  (action, index) => (
                                                    <React.Fragment key={index}>
                                                      <li key={index}>
                                                        {action}
                                                      </li>
                                                    </React.Fragment>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>

                                          {item.rf_goal_plot !== undefined &&
                                          item.rf_goal_plot !== null ? (
                                            <React.Fragment key={index}>
                                              <div>
                                                <div className="expected-cost-title mb-2">
                                                  Visual Insight
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                  }}
                                                >
                                                  <div
                                                    className="svg-container"
                                                    style={{ width: "unset" }}
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        item?.rf_goal_plot,
                                                    }}
                                                  />
                                                  <div
                                                    className="svg-view-icon"
                                                    style={{
                                                      position: "relative",
                                                      right: 40,
                                                      top: 5,
                                                    }}
                                                    title="Open image in new tab"
                                                    onClick={() =>
                                                      this.openSvgInNewTab(
                                                        item?.rf_goal_plot
                                                      )
                                                    }
                                                  >
                                                    <FaSearchPlus size={24} />
                                                  </div>
                                                </div>
                                              </div>
                                            </React.Fragment>
                                          ) : null}
                                        </div>
                                      </Collapse>
                                    </TabPane>
                                  </>
                                )
                              )}
                            </TabContent>
                            {/* <div
                              className="overviewTextCompParent"
                              style={{ paddingLeft: "20px" }}
                            >
                              {this.state.data.conservative?.summaryList &&
                                this.state.data.conservative.summaryList
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEnhanced - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.costSummaryText !==
                                        undefined &&
                                      filteredItem.costSummaryText !== null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            Expected Cost Effect
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={filteredItem.costSummaryText}
                                            data={
                                              filteredItem.costSummaryDescription
                                            }
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}

                              {this.state.data.conservative?.summaryList &&
                                this.state.data.conservative.summaryList
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEnhanced - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.perfSummaryText !==
                                        undefined &&
                                      filteredItem.perfSummaryText !== null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            Expected Performance Effect
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={filteredItem.perfSummaryText}
                                            data={
                                              filteredItem.perfSummaryDescription
                                            }
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}

                              {this.state.data.conservative?.vm &&
                                this.state.data.conservative.vm
                                  .filter(
                                    (item) =>
                                      item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEnhanced - 1
                                      )
                                  )
                                  .map(
                                    (filteredItem, index) =>
                                      filteredItem.gaiInsightSummary !==
                                        undefined &&
                                      filteredItem.gaiInsightSummary !==
                                        null && (
                                        <div
                                          key={index}
                                          className="maindiv-text-overview maindiv-text-overview-grad"
                                        >
                                          <div className="expected-cost-title">
                                            AI Insights
                                          </div>
                                          <ResingBenefitTextComponent
                                            title={
                                              filteredItem.gaiInsightSummary
                                            }
                                            data={[
                                              filteredItem.gaiInsightDescription,
                                            ]}
                                            isAsp={this.state.isAsp}
                                            entityType={this.state.entityType}
                                          />
                                        </div>
                                      )
                                  )}
                            </div>

                            {this.state.data.conservative?.vm &&
                              this.state.data.conservative.vm
                                .filter(
                                  (item) =>
                                    item.rf_goal_plot !== undefined &&
                                    item.rf_goal_plot !== null &&
                                    item.recommendationChoiceNum ===
                                      parseInt(
                                        this.state
                                          .activeTabRecommentionsEconomical - 1
                                      )
                                )
                                .map(
                                  (filteredItem, index) =>
                                    filteredItem.gaiInsightSummary !==
                                      undefined &&
                                    filteredItem.gaiInsightSummary !== null && (
                                      <React.Fragment key={index}>
                                        <hr
                                          style={{
                                            width: "98%",
                                            height: "10px",
                                          }}
                                        />
                                        <h6>
                                          {filteredItem?.recommendationChoiceNum ===
                                          0
                                            ? "Resource Fit Graph"
                                            : "Alternate " +
                                              filteredItem?.recommendationChoiceNum +
                                              " Recommendation Resource Fit Graph"}
                                        </h6>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "100%",
                                          }}
                                          className="svg-container"
                                          onClick={() =>
                                            this.openSvgInNewTab(
                                              filteredItem?.rf_goal_plot
                                            )
                                          }
                                          dangerouslySetInnerHTML={{
                                            __html: filteredItem?.rf_goal_plot,
                                          }}
                                        />
                                      </React.Fragment>
                                    )
                                )} */}
                          </Collapse>
                        </div>

                        {this.state.data &&
                        this.state.data.gaiValidationData &&
                        this.state.data.gaiValidationData.validationPerfType ===
                          "Conservative" ? (
                          <>
                            <div id="tab23">
                              <div
                                color="primary"
                                onClick={() => {
                                  this.toggleCollapse("23");
                                }}
                                className="collapsediv"
                              >
                                <div id="collapse_head">
                                  <div className="arrow">
                                    {!this.state.collapse.includes("23")
                                      ? CLOSE
                                      : OPEN}
                                  </div>
                                  <div id="overViewCollapseTitle">
                                    GAI Recommendation
                                  </div>
                                </div>{" "}
                                {!this.state.collapse.includes("23") ? (
                                  <div className="maindiv">
                                    <ColorComponent
                                      data={this.state.gaiIcondata[0].cpu}
                                      isResize={true}
                                      showInfo={false}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType === "db" ? (
                                      <ColorComponent
                                        data={this.state.gaiIcondata[0].disks}
                                        isResize={true}
                                        showInfo={false}
                                        isLine={true}
                                        isAsp={this.state.isAsp}
                                        entityType={this.state.entityType}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                    <ColorComponent
                                      data={this.state.gaiIcondata[0].memory}
                                      isResize={true}
                                      showInfo={false}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      hostOnly={hostOnly}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    <ColorComponent
                                      data={this.state.gaiIcondata[0].network}
                                      isResize={true}
                                      showInfo={false}
                                      isLine={
                                        this.state.entityType === "db"
                                          ? false
                                          : true
                                      }
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType !== "db" ? (
                                      <ColorComponent
                                        data={this.state.gaiIcondata[0].disks}
                                        isResize={true}
                                        showInfo={false}
                                        isLine={false}
                                        isAsp={this.state.isAsp}
                                        entityType={this.state.entityType}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                  </div>
                                ) : null}{" "}
                              </div>
                              <Collapse
                                isOpen={this.state.collapse.includes("23")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <GaiRecommend
                                      data={this.state.data.gaiValidationData}
                                      iconData={this.state.gaiIcondata}
                                      isResize={true}
                                      isLine={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      userCurrency={
                                        this.state.data?.userCurrency
                                      }
                                      providerName={this.state.providerName}
                                    ></GaiRecommend>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </div>
                            <div id="tab24">
                              <div
                                color="primary"
                                onClick={() => {
                                  this.toggleCollapse("24");
                                }}
                                className="collapsediv resize-collapsediv"
                              >
                                <div
                                  id="collapse_head"
                                  style={{
                                    minHeight: "102px",
                                    maxWidth: "28%",
                                  }}
                                >
                                  <div className="arrow">
                                    {!this.state.collapse.includes("24")
                                      ? CLOSE
                                      : OPEN}
                                  </div>
                                  <div id="overViewCollapseTitle">
                                    Expected Benefits & Drawbacks of GAI
                                    Recommendation
                                  </div>{" "}
                                </div>{" "}
                                {!this.state.collapse.includes("24") ? (
                                  <div className="overviewTextCompParent">
                                    {this.state.data.gaiValidationData !==
                                      undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .costSummaryText !== undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .costSummaryText !== null ? (
                                      <div className="maindiv-text-overview maindiv-text-overview-grad">
                                        <ResingBenefitTextComponent
                                          title={
                                            this.state.data.gaiValidationData
                                              .summary.costSummaryText
                                          }
                                          data={
                                            this.state.data.gaiValidationData
                                              .summary.costSummaryDescription
                                          }
                                          isAsp={this.state.isAsp}
                                          entityType={this.state.entityType}
                                        />
                                      </div>
                                    ) : null}
                                    {this.state.data.gaiValidationData !==
                                      undefined &&
                                    this.state.data.gaiValidationData.summary
                                      .perfSummaryText !== undefined &&
                                    this.state.data.balanced.summary
                                      .perfSummaryText !== null ? (
                                      <div className="maindiv-text-overview maindiv-text-overview-grad">
                                        <ResingBenefitTextComponent
                                          data={
                                            this.state.data.gaiValidationData
                                              .summary.perfSummaryDescription
                                          }
                                          title={
                                            this.state.data.gaiValidationData
                                              .summary.perfSummaryText
                                          }
                                          isAsp={this.state.isAsp}
                                          entityType={this.state.entityType}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                ) : null}
                              </div>
                              <Collapse
                                isOpen={this.state.collapse.includes("24")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <GaiResize
                                      data={this.state.data.gaiValidationData}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      userCurrency={
                                        this.state.data?.userCurrency
                                      }
                                      providerName={this.state.providerName}
                                    ></GaiResize>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            </div>
                          </>
                        ) : null}

                        {this.state.isValidationGraphTable === false &&
                        this.state.data.validationData !== null &&
                        this.state.data.validationData !== undefined &&
                        this.state.data.validationData.perfType ===
                          "Conservative" ? (
                          <div id="tab16">
                            <div
                              onClick={() => {
                                this.toggleCollapse("16");
                              }}
                              className="collapsediv"
                            >
                              <div id="collapse_head">
                                <div className="arrow">
                                  {!this.state.collapse.includes("16")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div>
                                  <div id="overViewCollapseTitle">
                                    Validation :
                                  </div>
                                  <div>
                                    <b>Enhanced</b>
                                  </div>
                                  <div>{bvmStatus}</div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("16") ? (
                                this.state.healthyIcondata.length > 0 ? (
                                  <div className="maindiv">
                                    <ColorComponent
                                      data={this.state.healthyIcondata[0].cpu}
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Enhanced"
                                      valData={this.state.data.validationData}
                                      showCostPerfMarker={true}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType === "db" ? (
                                      <ColorComponent
                                        data={
                                          this.state.healthyIcondata[0].disks
                                        }
                                        isResize={true}
                                        isLine={true}
                                        showInfo={false}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        forValidation={true}
                                        valObjective="Enhanced"
                                        valData={this.state.data.validationData}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                    <ColorComponent
                                      data={
                                        this.state.healthyIcondata[0].memory
                                      }
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Enhanced"
                                      valData={this.state.data.validationData}
                                      hostOnly={hostOnly}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    <ColorComponent
                                      data={
                                        this.state.healthyIcondata[0].network
                                      }
                                      isResize={true}
                                      isLine={
                                        this.state.entityType === "db"
                                          ? false
                                          : true
                                      }
                                      showInfo={false}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      forValidation={true}
                                      valObjective="Enhanced"
                                      valData={this.state.data.validationData}
                                      fromOverview={true}
                                    ></ColorComponent>
                                    {this.state.entityType !== "db" ? (
                                      <ColorComponent
                                        data={
                                          this.state.healthyIcondata[0].disks
                                        }
                                        isResize={true}
                                        isLine={false}
                                        showInfo={false}
                                        isIcon={true}
                                        valStatus={bvmStatus}
                                        forValidation={true}
                                        valObjective="Enhanced"
                                        valData={this.state.data.validationData}
                                        fromOverview={true}
                                      ></ColorComponent>
                                    ) : null}
                                  </div>
                                ) : null
                              ) : null}
                            </div>
                            <Collapse
                              isOpen={this.state.collapse.includes("16")}
                              className="collapseTransition"
                            >
                              <Card style={{ border: "none" }}>
                                <CardBody style={{ border: "none" }}>
                                  <div>
                                    <ValidationTable
                                      data={
                                        this.state.recommendationData
                                          .conservative
                                      }
                                      valTableData={
                                        this.state.data.validationData
                                      }
                                      iconData={this.state.healthyIcondata}
                                      isResize={true}
                                      isLine={true}
                                      isIcon={true}
                                      valStatus={bvmStatus}
                                      valObjective="Enhanced"
                                      showValidationDetails={
                                        this.showValidationDetails
                                      }
                                    ></ValidationTable>
                                  </div>
                                </CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        ) : null}
                        {this.state.isValidationGraphTable === false &&
                        this.state.data.validationData !== null &&
                        this.state.data.validationData !== undefined &&
                        this.state.data.validationData.perfType ===
                          "Conservative" &&
                        bvmStatus === "VALIDATED" ? (
                          <div id="tab17">
                            <div
                              onClick={() => {
                                this.toggleCollapse("17");
                              }}
                              className="collapsediv"
                            >
                              <div
                                id="collapse_head"
                                style={{ maxWidth: "29%" }}
                              >
                                <div className="arrow">
                                  {!this.state.collapse.includes("17")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div>
                                  <div id="overViewCollapseTitle">
                                    Validated Benefits & Drawbacks of
                                    Recommendation :{" "}
                                  </div>
                                  <div>
                                    <b>Enhanced</b>
                                  </div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("17") ? (
                                <div className="overviewTextCompParent">
                                  {this.state.data.conservative !== undefined &&
                                  this.state.data.conservative
                                    .validation_summary.costSummaryText !==
                                    undefined &&
                                  this.state.data.conservative
                                    .validation_summary.costSummaryText !==
                                    null ? (
                                    <div className="maindiv-text-overview maindiv-text-overview-grad">
                                      <ResingBenefitTextComponent
                                        title={
                                          this.state.data.conservative
                                            .validation_summary.costSummaryText
                                        }
                                        data={
                                          this.state.data.conservative
                                            .validation_summary
                                            .costSummaryDescription
                                        }
                                        affectString={
                                          this.state.data.conservative
                                            .validation_summary.perfAffected
                                        }
                                        valResult={
                                          this.state.data.conservative
                                            .validation_summary
                                            .validation_cost_result
                                        }
                                        renderIcon={
                                          this.state.data.validationPerfType !==
                                            null &&
                                          this.state.data.validationPerfType ===
                                            "Conservative" &&
                                          this.state.data.bvmState !==
                                            "VALIDATING"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                  {this.state.data.conservative !== undefined &&
                                  this.state.data.conservative
                                    .validation_summary.perfSummaryText !==
                                    undefined &&
                                  this.state.data.conservative
                                    .validation_summary.perfSummaryText !==
                                    null ? (
                                    <div className="maindiv-text-overview maindiv-text-overview-grad">
                                      <ResingBenefitTextComponent
                                        data={
                                          this.state.data.conservative
                                            .validation_summary
                                            .perfSummaryDescription
                                        }
                                        title={
                                          this.state.data.conservative
                                            .validation_summary.perfSummaryText
                                        }
                                        affectString={
                                          this.state.data.conservative.summary
                                            .increasedCost
                                        }
                                        valResult={
                                          this.state.data.conservative
                                            .validation_summary
                                            .validation_perf_result
                                        }
                                        renderIcon={
                                          this.state.data.validationPerfType !==
                                            null &&
                                          this.state.data.validationPerfType ===
                                            "Conservative" &&
                                          this.state.data.bvmState !==
                                            "VALIDATING"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                            <Collapse
                              isOpen={this.state.collapse.includes("17")}
                              className="collapseTransition"
                            >
                              <Card style={{ border: "none" }}>
                                <CardBody style={{ border: "none" }}>
                                  <div>
                                    <ValidationDetailsTable
                                      data={this.state.data.validationData}
                                      isValidationGraphTable={false}
                                      valSummary={
                                        this.state.data.conservative
                                          .validation_summary
                                      }
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        ) : null}
                        {this.state.recommendationData.conservative !==
                          undefined &&
                        this.state.recommendationData.conservative
                          .isRecommendationSelected === true ? (
                          <div id="tab18">
                            <div
                              onClick={() => {
                                this.toggleCollapse("18");
                              }}
                              className="collapsediv"
                            >
                              <div id="collapse_head">
                                <div className="arrow">
                                  {!this.state.collapse.includes("18")
                                    ? CLOSE
                                    : OPEN}
                                </div>
                                <div id="overViewCollapseTitle">
                                  Resizing Status :{" "}
                                  <div
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {this.state.recommendationData.bvmState}{" "}
                                    {this.state.recommendationData.bvmState ===
                                    "OPTIMIZING" ? (
                                      <i
                                        style={{ margin: "auto 14px" }}
                                        className="fa fa-info-circle"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="left"
                                        title="When manual resizing has been completed, please mark it as complete using Manage VMs page"
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              {!this.state.collapse.includes("18") &&
                              this.state.healthyIcondataStatus.length > 0 ? (
                                <div className="maindiv">
                                  <ColorComponent
                                    data={
                                      this.state.healthyIcondataStatus[0].cpu
                                    }
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    showCostPerfMarker={true}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  {this.state.entityType === "db" ? (
                                    <ColorComponent
                                      data={
                                        this.state.healthyIcondataStatus[0]
                                          .disks
                                      }
                                      isResize={true}
                                      isLine={true}
                                      showInfo={false}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  ) : null}
                                  <ColorComponent
                                    data={
                                      this.state.healthyIcondataStatus[0].memory
                                    }
                                    isResize={true}
                                    isLine={true}
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    hostOnly={hostOnly}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  <ColorComponent
                                    data={
                                      this.state.healthyIcondataStatus[0]
                                        .network
                                    }
                                    isResize={true}
                                    isLine={
                                      this.state.entityType === "db"
                                        ? false
                                        : true
                                    }
                                    showInfo={false}
                                    isIcon={true}
                                    isAsp={this.state.isAsp}
                                    entityType={this.state.entityType}
                                    fromOverview={true}
                                    type="recommendation"
                                  ></ColorComponent>
                                  {this.state.entityType !== "db" ? (
                                    <ColorComponent
                                      data={
                                        this.state.healthyIcondataStatus[0]
                                          .disks
                                      }
                                      isResize={true}
                                      isLine={false}
                                      showInfo={false}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      fromOverview={true}
                                      type="recommendation"
                                    ></ColorComponent>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                            {this.state.healthyIcondataStatus.length > 0 ? (
                              <Collapse
                                isOpen={this.state.collapse.includes("18")}
                                className="collapseTransition"
                              >
                                <Card style={{ border: "none" }}>
                                  <CardBody style={{ border: "none" }}>
                                    <Recommendstatus
                                      data={
                                        this.state.recommendationData
                                          .conservative
                                      }
                                      iconData={
                                        this.state.healthyIcondataStatus
                                      }
                                      isResize={true}
                                      isLine={true}
                                      isIcon={true}
                                      isAsp={this.state.isAsp}
                                      entityType={this.state.entityType}
                                      providerName={this.state.providerName}
                                      type="recommendation"
                                    ></Recommendstatus>
                                  </CardBody>
                                </Card>
                              </Collapse>
                            ) : null}
                          </div>
                        ) : null}
                      </TabPane>
                    </TabContent>
                  </div>
                )}

                {this.state.modal ? (
                  <div id="details">
                    {(() => {
                      switch (this.state.activeTab) {
                        case "1":
                          return (
                            <CostHealthModal
                              data={this.state.data.aggressive}
                              type={"Economical"}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              userCurrency={this.state.data?.userCurrency}
                              providerName={this.state.providerName}
                            ></CostHealthModal>
                          );
                        case "2":
                          return (
                            <CostHealthModal
                              data={this.state.data.balanced}
                              type={"Balanced"}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              userCurrency={this.state.data?.userCurrency}
                              providerName={this.state.providerName}
                            ></CostHealthModal>
                          );
                        case "3":
                          return (
                            <CostHealthModal
                              data={this.state.data.conservative}
                              type={"Enhanced"}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              userCurrency={this.state.data?.userCurrency}
                              providerName={this.state.providerName}
                            ></CostHealthModal>
                          );
                      }
                    })()}
                  </div>
                ) : this.state.isValidationGraphTable ? (
                  <div id="details">
                    <ValidationDetailsTable
                      data={this.state.data.validationData}
                      isValidationGraphTable={this.state.isValidationGraphTable}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {this.state.errorPopup === true ? (
            <SerraError
              Errordata={this.state.errormessage}
              ErrorPopup={this.state.errorPopup}
              setErrorMethod={this.setErrorPopupState}
              isError={this.state.isErrorHeader}
            ></SerraError>
          ) : (
            ""
          )}
          {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
        </div>

        {this.state.isClientSidePDF && this.state.data && (
          <>
            <EntityTypeSummary
              companiesDetails={this.props.companyDetails}
              data={this.state.data}
              isMargin={true}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              userGmtId="IST"
              userTimeZone="Asia/Calcutta"
              analysisCnt={1}
              enhancedCostRatio={this.state.enhancedCostRatio}
              economicalPerfRatio={this.state.economicalPerfRatio}
              providerName={this.state.providerName}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
  };
};

export default connect(mapStateToProps, null)(withRouter(Overview));
